var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 45,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#AA151B",
    d: "M0 0h60v45H0V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1BF00",
    d: "M0 11.3h60v22.4H0V11.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "M12 20h-.1l-.1-.1h-.1v-.1s-.1-.1 0-.2v-.1h.2v-.1h.2l.1-.1h1l.3.1v.1l.1.1v.2l-.1.1-.2.1H12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12.3 19.3h.7a3.3 3.3 0 0 0 .5.1v.1l.1.1v.4h-.2v.1h-.8a3.2 3.2 0 0 0-.7 0h-.1l-.1-.1v-.1h-.1v-.2l.1-.2h.4v-.1h.2Zm-.6.5.2.2a2.6 2.6 0 0 1 .3 0h.4a3.7 3.7 0 0 1 .7 0h.1v-.1l.1-.1v-.4h-.2v-.1a3.4 3.4 0 0 1-.4-.1H12l-.1.1h-.2v.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m12.5 19.4.1-.2s.2 0 .2.2l-.2.2-.1-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12.5 19.3v.3h.2v-.4h-.2Zm0 0 .1-.1h.1v.4h-.2v-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M12.6 19.4v-.2.4-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12.6 19.4v.2a.6.6 0 0 0 0-.4v.2Zm0-.1v.4",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m12.5 19.2.1-.1h.1v.2l-.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M12.7 19.1v.1h-.1V19h.1v.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12.6 19h.1v.2h-.2V19Zm0 0v.2-.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M12.7 19.1v.1h-.2.1V19h.1v.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12.6 19h.1v.2h-.2V19Zm0 0v.2h.1V19Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12.6 19.1v.1-.1h.1v.2h-.1V19Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M12.6 20h-.4v-.4l-.3-.2c.1-.1.3 0 .5.3h.4c.2-.3.4-.4.5-.4v.1l-.2.2v.4h-.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12.9 19.7h-.5a1 1 0 0 0-.3-.3h-.2l.3.2v.4h.8v-.4h.1l.2-.2H13l-.2.3Zm.4-.4H13l-.3.4h-.3a1 1 0 0 0-.4-.3c-.1-.1-.2-.1-.2 0l.2.2v.4h1v-.4l.2-.1c0-.1 0 0 0 0h.1v-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M13.3 19.4h-.1l-.3.3.3-.3Zm-1.3 0h-.1.2l.2.3-.2-.2-.1-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M12 20.2V20h1.3v.1h-.7a2 2 0 0 0-.6 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12 20.1v.1h1.2V20H12Zm0 0h1.3v.1h-.7a2 2 0 0 0-.6 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M12.6 20.4h.6v-.1l-.6-.1a2 2 0 0 0-.6 0v.2h.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12 20.2h1.2v.1a3 3 0 0 1-1.1 0H12Zm.6 0a2 2 0 0 0-.6 0v.1a3.1 3.1 0 0 0 1.2 0l-.6-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M13.3 20h-.1l-.1-.1H12v.1a2.5 2.5 0 0 1 1.3 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m12.6 19.8.1.1h.4a.2.2 0 0 0 .2 0v.2l-.7-.1H12a.3.3 0 0 0 .2 0v-.1h.2a.2.2 0 0 0 .1 0h.1a.3.3 0 0 0 .1 0Zm-.2 0v.1H12v.1a2.5 2.5 0 0 1 1.3 0 .3.3 0 0 1-.1 0H13v-.1h-.7Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M12.6 19.8h.2l.2.1v-.1h.1v.1h.4v.1H13a.1.1 0 0 1-.2-.1.2.2 0 0 1-.1 0 .1.1 0 0 1-.3 0 .2.2 0 0 1-.1 0 .1.1 0 0 1-.1 0H12v.1h-.2v-.1h.3v-.1l.2.1v-.1h.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12.1 19.7h.1v.1h.9v.1h.4l-.1.1H13a.2.2 0 0 1-.2 0 .2.2 0 0 1-.2 0 .2.2 0 0 1-.2 0 .2.2 0 0 1-.1 0 .2.2 0 0 1-.1 0h-.4v-.2.1a.2.2 0 0 0 .1 0h.2v-.2Zm1.4.2a.3.3 0 0 1-.2 0 .1.1 0 0 1-.2 0v-.1l-.1.1h-.3v-.1h-.1l-.1.1h-.2a.1.1 0 0 1-.1 0v-.1a.1.1 0 0 1-.1.2H12a.1.1 0 0 1-.1 0l-.1-.1v.1h.4v-.1a.1.1 0 0 0 .2 0 .1.1 0 0 0 .2 0 .1.1 0 0 0 .1 0h.1a.1.1 0 0 0 .2 0h.2v.1h.4a.4.4 0 0 0 0-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M12.6 20H12h1.4-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12 20h1.2H12Zm1.3 0v.1a2.5 2.5 0 0 0-1.4 0l.7-.2a2.5 2.5 0 0 1 .7.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.4 20.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12.4 20v.1Zm0 .1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "M12.6 20.1h.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12.5 20h.2v.1h-.2Zm.2.1h-.2.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#058E6E",
    d: "M12.2 20.1H12h.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12.2 20.1Zm0 0h.1-.2.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "M12 20.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12 20.1v.1Zm0 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.8 20.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12.9 20v.1Zm0 0v.1h-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#058E6E",
    d: "M13 20.1h.1-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M13 20h.1v.1H13Zm0 .1h.1-.1Zm.2 0h.1v.1h-.1Zm0 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "m12.6 20.4-.5-.1h1-.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12.1 20.3h1-1Zm0 0a2.4 2.4 0 0 1 1.1 0h-.6a2.3 2.3 0 0 1-.6 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M13.3 19.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M13.3 19.8v.1Zm0 0Zm-.5-.1h.1v.1Zm0 0v.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M12.4 19.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12.4 19.7v.1Zm0 .1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M12 19.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12 19.9Zm0 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M12.6 19.5v.2l.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12.6 19.5h.1v.2h-.1v-.1Zm0 0v.2-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M12.5 19.7h.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12.5 19.7h.1l-.1.1v-.1Zm0 0h.1-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M12.8 19.7h-.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12.8 19.7v.1h-.2v-.1h.2Zm-.2 0h.2-.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M12.1 19.6v.2l.1-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12.1 19.6h.1v.2l-.2-.1.1-.1Zm0 0v.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M12 19.8h.2-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12 19.7h.1v.1H12Zm0 0v.1h.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M12.3 19.7h-.1.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12.3 19.7v.1h-.1v-.1Zm0 0h-.1.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M11.9 19.8h-.2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M11.8 19.8v.1h-.1l.1-.1Zm0 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M12.1 19.8h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12.1 19.8Zm0 0h.1-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M13.1 19.6v.2-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M13.1 19.6v.2l.1-.1v-.1Zm0 0v.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M13.3 19.8H13h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M13.2 19.7v.1h-.1.1Zm0 .1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M13 19.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M13 19.7h.1v.1h-.2v-.1Zm0 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M13.4 19.8h.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M13.4 19.8h.1v.1h-.1v-.1Zm0 0h.1-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M12.6 19.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12.6 19.7Zm0 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M13 19.8h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M13 19.8h.1Zm0 0h.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m11.7 19.9-.1-.1h.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M11.7 19.8v.1h-.1v-.1Zm0 0Zm0 0v.1Zm0 0v.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m13.5 19.9.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M13.6 19.8v.1h-.1v-.1Zm0 0Zm-.1 0v.1Zm0 0v.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M11.6 21h2v-.6h-2v.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M11.6 20.4h2v.5h-2v-.5Zm0 .5v-.5h2v.5h-2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M11.8 21.3h1.6a.1.1 0 0 1 0-.2h-1.5a.1.1 0 0 1 0 .2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M11.8 21h1.6v.1a.1.1 0 0 0 0 .1H12V21Zm.1.2h1.4V21H12v.1a.1.1 0 0 1 0 .1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M11.9 21.3h1.5v.1h-1.6v-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M11.8 21.3h1.6-1.5Zm0 0v.1h1.6v-.1h-1.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M11.9 21h1.5-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M11.9 20.9h-.1v.1h1.6v-.1h-1.5Zm0 0h-.1v.1h1.6-1.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005BBF",
    d: "m14 29.8-.3-.1c-.1 0-.3-.1-.4 0h-1c-.1 0-.3-.1-.4 0h-.7v.3l.4-.1H14v-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M13.3 29.6h.4l.3.1v.3h-.3l-.4-.2-.3.1-.4.1h-.3l-.4-.2-.3.1-.4.1v-.3h.4l.3-.1h.4l.3.1h.4l.3-.1Zm0 0Zm.4.1h-2.5v.3l.4-.1.3-.1h.4l.3.2.4-.1.3-.1h.4l.3.2v-.2l-.3-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "m14 30-.3-.1h-2.5v.3h.4l.3-.2.4.1a.8.8 0 0 0 .7 0 .8.8 0 0 1 .7 0l.3.1V30Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M13.3 29.8h.4l.3.2v.2h-.3a.8.8 0 0 0-.7 0 .8.8 0 0 1-.7 0l-.4-.1h-.3l-.4.1V30l.4-.1.3-.1h.4l.3.2.4-.1.3-.1Zm.7.2h-.3l-.4-.2-.3.1-.4.1h-.3l-.4-.2-.3.1-.4.1v.2l.4-.1h.7a.8.8 0 0 0 .7 0 .8.8 0 0 1 .7 0h.3V30Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005BBF",
    d: "M14 30.2h-.3l-.4-.2-.3.1-.4.1h-.3l-.4-.2-.3.1-.4.1v.2h.4c.2-.2.4-.2.7 0h.7l.3-.1h.4l.3.1v-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m12 30 .3.1H14v.3h-.3l-.4-.1H13l-.4.1h-.3a1 1 0 0 0-.7 0h-.4v-.2l.4-.1h.3Zm-.4.1-.4.1v.2h.4c.2-.2.5-.2.7 0h.7l.3-.2.4.1h.3l-.3-.2H13l-.4.1h-.3l-.4-.1h-.3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M14 30.6h-.3l-.4-.1H13l-.4.1h-.3l-.4-.1h-.3l-.4.1v-.2h.4c.2-.2.4-.2.7 0h.7l.3-.1h.4l.3.1v.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M13.3 30.3H13l-.4.1h-.3a1 1 0 0 0-.7 0h-.4v.2h.4l.3-.1h.4l.3.1h.4l.3-.1h.4l.3.1v-.2h-.3l-.4-.1Zm.7.3v-.2h-.3l-.4-.2-.3.1c-.1 0-.3.1-.4 0h-.3a1 1 0 0 0-.7 0h-.4v.3h.4l.3-.1h.4c0 .1.2.2.3.1h.4l.3-.1h.4c0 .1.2.2.3.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005BBF",
    d: "M14 30.8h-.3l-.4-.1H13l-.4.1h-.3l-.4-.1h-.3l-.4.1v-.2h.4l.3-.1h.4a.8.8 0 0 0 .7 0h.7l.3.1v.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12 30.5h-.4l-.4.1v.2h.4l.3-.1h.4l.3.1h.4l.3-.1h.4l.3.1v-.2h-.3l-.4-.1a1 1 0 0 0-.3 0 .8.8 0 0 1-.7 0h-.4Zm2 .3v-.2h-.3l-.4-.1a1 1 0 0 0-.3 0 .8.8 0 0 1-.7 0 1 1 0 0 0-.4 0h-.3l-.4.1v.3l.4-.1H14Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M11.8 28.9c0 .2 0 .3-.2.3h2a.3.3 0 0 1-.2-.3h-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M13.4 28.9a.2.2 0 0 0 .3.2h-2.1c.1 0 .2 0 .2-.2h1.6Zm-1.5 0c0 .1 0 .2-.2.2h1.8a.3.3 0 0 1-.1-.2h-1.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M11.9 28.7h1.5v.1h-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M11.8 28.8h1.6-1.5Zm0 0h1.6-1.6Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M11.6 29.7h2v-.5h-2v.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M11.6 29.1h2v.6h-2v-.6Zm0 0v.6h2v-.5h-2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "M11.4 26.9c-.2 0-.3.2-.3.3l.2.1c.1.1.2.3.1.4a.5.5 0 0 0 0-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m11.2 27 .2-.1a.5.5 0 0 1 0 .8v-.2l-.1-.2h-.1l-.1-.1V27Zm.2-.1-.2.2v.1l.1.1.2.2v.1a.5.5 0 0 0 0-.7Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M11.9 28.6h1.5v-7.1h-1.5v7.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M11.9 21.5h1.5v7.2h-1.5v-7.2Zm0 7.1v-7.1h1v7.1h-1Zm1 0h.2v-7.1H13v7.1Zm.2-7.1v7.1h.2v-7.1h-.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "M14.8 24.2c-.7-.3-1.4-.3-2.1-.2-1 .1-1.6.5-1.5.8l-.4-.8c0-.3.7-.7 1.7-.9h.9c.6 0 1.1 0 1.4.2v.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M13.4 23.1a4 4 0 0 0-.9 0l-1.2.4-.3.3-.1.2.3.7v-.2l.4-.2c.2-.1.6-.3 1-.3a4 4 0 0 1 2.2.1v-.8l-1.4-.2Zm1.5 1c-.8-.2-1.5-.2-2.2-.1-.5 0-.9.2-1.1.3l-.3.2-.1.3-.4-.8.1-.2.4-.3 1.2-.4h.9a4.6 4.6 0 0 1 1.5.2v.9Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "M11.9 25c-.4 0-.7 0-.7-.2s0-.3.3-.5h.4v.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M11.5 24.3h.4v.8l-.5-.1-.2-.2v-.3l.3-.2Zm0 0-.2.3-.1.2.2.1.5.1v-.6h-.3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "m13.4 24.5.5.2-.5.5v-.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M13.4 24.5v.8l.4-.4h.1v-.2l-.2-.1-.3-.1Zm.3.1h-.3v.6l.4-.3v-.1l-.1-.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "M11 26.4s.3-.3.9-.5l.7-.3c.8-.4 1.4-.7 1.3-.9l.1.7c0 .2-.5.6-1.2.9l-.9.4c-.4.1-.8.4-.8.5l-.1-.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M13.9 24.7v.1a6.3 6.3 0 0 1 .1.6v.1c0 .2-.2.2-.3.3a5.5 5.5 0 0 1-1.3.7h-.2l-.3.2a2.4 2.4 0 0 0-.7.4H11l-.1-.6v-.1l.2-.2.7-.3.7-.3a6.2 6.2 0 0 0 1.2-.8v-.1h.1ZM11.1 27l.2-.2.6-.2.3-.2h.2l.4-.2a5.5 5.5 0 0 0 1.1-.7v-.1a10.8 10.8 0 0 0 0-.7l-.3.3-1 .5-.7.3a4.4 4.4 0 0 0-.9.4v.1l.1.7Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M11.8 23.8c.2 0 .3-.1.2-.3h-.5l.2.6h.1v-.3Zm-.1-.2h.2v.1h-.1l-.1-.1Zm.7-.3h-.1v.6h.4v-.1h-.2l-.1-.5m.8.5.2-.6-.3.5-.2-.4h-.2l.4.5Zm.8-.4v-.1l-.3.1c0 .2.3.2.3.3 0 0 0 .1-.2 0h-.1l.1.1.3-.1c0-.2-.3-.2-.3-.3l.1-.1h.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "M26 19.8v.1h-.7v.1h-.1l-.1-.1-.1-.1c0-.1 0-.2.2-.2h.2l.3-.1h1l.2.2v.2h-.2s0 .1 0 0H26Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M26.3 19.5h-1l-.1.1v.4h.2a.2.2 0 0 0 .1 0h.5a.3.3 0 0 0 .1 0h.9v-.4h-.4l-.2-.1Zm0 .4h-.1a.3.3 0 0 1-.1 0h-.5a.2.2 0 0 1-.2 0v.1h-.1l-.1-.1-.1-.1v-.2h.4l.1-.1a.7.7 0 0 1 .5 0h.7l.2.1v.4h-.1l-.1.1h-.2l-.1-.1h-.1a.2.2 0 0 1-.1 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M26 19.5v-.2c.1 0 .2 0 .2.2l-.2.1v-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M26 19.5v.1h.1v-.3H26v.2Zm0 0v-.2h.1v.3h-.2v-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M26 19.5v-.2l.1.2v.1l-.1-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M26 19.5v.1l.1-.1v-.2.2Zm0 0v-.2h.1v.3H26v-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M25.4 20.2V20h1.3v.1h-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M25.4 20.1v.1h1.3V20h-1.3Zm0 0c.4-.2.9-.2 1.4 0h-.1v.1h-1.3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M26 20.4h.6v-.1l-.6-.1a2 2 0 0 0-.6 0l.1.2h.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M26 20.2h.7v.1h-.1a3 3 0 0 1-1.1 0h-.1l.6-.1Zm.6 0H26a2 2 0 0 0-.6 0v.1h.1a3.1 3.1 0 0 0 1 0h.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.6 19.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M26.3 19.3h.1Zm0 0h.1Zm0 0h-.1Zm-.1 0Zm.3 0Zm0 0Zm.1 0v.1Zm0 0v.1Zm0 .2Zm0 0Zm.1-.1a.3.3 0 0 1 .3.3v.1-.1a.2.2 0 0 0-.2-.2h-.2.1Zm-.5 0h.1l.3.1v.1c0-.2-.2-.2-.3-.2h-.1Zm.6-.1v.1Zm0 0v.1Zm-.1 0v.1Zm0 0v.1Zm.3.1Zm-.1 0h.1-.1Zm.2.1Zm0 0H27Zm0 .2Zm0 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M26.7 20h-.1l-.1-.1h-1.1v.1a2.5 2.5 0 0 1 1.3 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m26 19.8.2.1h.4a.2.2 0 0 0 .2 0v.2l-.6-.1h-.7.1v-.1h.2a.1.1 0 0 0 .1 0h.2Zm-.2 0a.2.2 0 0 1-.2.1h-.2v.1a2.5 2.5 0 0 1 1.3 0h-.2v-.1h-.1a.1.1 0 0 1-.1 0h-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.4 19.5h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M25.7 19.2v.1Zm0 0v.1Zm.1 0v.1Zm0 0h.1v.1h-.1Zm-.3.1h.1m0 0Zm-.1 0v.1Zm0 0v.1Zm0 .2Zm0 0Zm-.2 0a.2.2 0 0 0-.2.1v.2a.3.3 0 0 1 .1-.3h.1m.2 0h-.2m0 0h.2m.5-.1h-.4v.2-.2a.3.3 0 0 1 .3 0Zm-.2 0Zm-.5-.1v.1Zm0 0v.1Zm.1 0v.1Zm0 0v.1Zm-.3.1Zm0 0Zm-.1.1h.1-.1Zm0 0Zm0 .2Zm0 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M26 19.8h.2l.2.1v-.1h.1l.1.1h.4v.1h-.4a.1.1 0 0 1-.1 0l-.1-.1h-.5a.1.1 0 0 1-.2 0h-.1l-.1.1h-.2v-.1h.4v-.1l.1.1h.1v-.1h.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M25.6 19.7v.1h.9l.1.1h.4v.1h-.4a.2.2 0 0 1-.1 0H26a.2.2 0 0 1-.2 0h-.5v-.2.1a.2.2 0 0 0 .1 0h.3v-.2Zm-.3.3Zm1.6 0a.3.3 0 0 1-.1 0h-.1a.1.1 0 0 1-.2 0v-.2l-.1.1h-.1a.1.1 0 0 1-.1 0l-.1-.1-.2.1h-.4v-.1a.1.1 0 0 1-.1.2h-.2v-.1l.1.1h.4v-.1h.1a.1.1 0 0 0 .1 0h.5a.1.1 0 0 0 .2 0h.1l.1.1h.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M26 20h-.6 1.4-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M25.4 20h1.3-1.3Zm1.4 0h-1.5v.1h1.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.8 20.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M25.8 20v.1Zm0 0v.2-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "M26 20.1h.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M26 20h.1v.1H26Zm.1.1H26h.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#058E6E",
    d: "M25.6 20.1h.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M25.7 20.1h-.2.1Zm0 0h-.2.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "M25.4 20.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M25.4 20.1v.1Zm0 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.2 20.1h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M26.3 20v.1Zm0 0v.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#058E6E",
    d: "M26.5 20.1h-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M26.4 20h.2v.1h-.2Zm0 .1h.2-.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "M26.7 20.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M26.6 20.1h.1v.1Zm.1 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "m26 20.4-.5-.1a2.4 2.4 0 0 1 1.1 0h-.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M25.5 20.3h1.1-1.1Zm.5 0a2.4 2.4 0 0 0-.5 0h.5a2.4 2.4 0 0 0 .6 0H26Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M26.7 19.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M26.7 19.8v.1Zm0 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M26.3 19.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M26.3 19.7v.1Zm0 0v.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M25.8 19.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M25.8 19.8Zm0 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M25.4 19.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M25.4 19.9Zm0 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M26 19.5v.2l.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M26 19.5h.1v.2l-.1-.1Zm0 0v.2l.1-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M25.9 19.7h.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M26 19.7v.1h-.1v-.1Zm0 0h-.1.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M26.2 19.7H26h.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M26.2 19.7v.1H26v-.1Zm0 0H26h.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M25.5 19.6v.2h.1v-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M25.5 19.6h.1v.2l-.1-.1v-.1Zm0 0v.1h.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M25.4 19.8h.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M25.4 19.7h.2v.1h-.2Zm0 .1h.2-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M25.8 19.7h-.2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M25.7 19.7v.1h-.1l.1-.1Zm0 0h-.1.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M25.3 19.8h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M25.2 19.8h.1l-.1.1v-.1Zm0 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M25.5 19.8h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M25.6 19.8Zm0 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M26.6 19.6v.2h-.1v-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M26.5 19.6v.2l.1-.1v-.1Zm0 0v.1h.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M26.7 19.8h-.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M26.7 19.7v.1h-.2.2Zm0 .1h-.2.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M26.3 19.7h.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M26.4 19.7h.1v.1h-.1v-.1Zm0 0h.1-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M26.8 19.8h.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M26.8 19.8h.1v.1h-.1v-.1Zm0 0h.1-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M26 19.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M26 19.7Zm0 0h.1-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M26.5 19.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M26.5 19.8Zm0 0",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M26 19.3v-.1h.1v.1H26Zm.1-.1H26V19h.1v.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M26 19h.1v.3H26V19Zm0 0v.2h.1v-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M26.2 19.2h-.3.1V19h.1v.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M26.1 19.2v.1a.1.1 0 0 1-.1 0v-.1.1h.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m25.1 19.9-.1-.1h.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M25 19.8h.1Zm.1 0v.1H25v-.1h.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M25.1 19.9s.1 0 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M25.1 19.9h.1Zm0 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M27 19.9v-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M27 19.8v.1-.1Zm0 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M27 19.9h-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M27 19.8v.1h-.1Zm0 0-.1.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M25 21h2v-.6h-2v.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M25 20.4h2v.5h-2v-.5Zm0 .5v-.5h2v.5h-2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M26.8 21.3h-1.5V21h1.6-.2l.1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M25.2 21h1.6v.2h-1.5V21Zm1.6 0h-1.5v.2h1.5V21Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M25.3 21.3h1.6l-.1.1h-1.5v-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M25.3 21.3h1.5-1.5Zm0 0h-.1l.1.1h1.6v-.1h-1.6Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M25.3 21h1.6-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M25.3 20.9h-.1v.1H27l-.1-.1h-1.5Zm0 0v.1h1.5-1.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005BBF",
    d: "m24.7 29.8.3-.1c.1 0 .2-.1.4 0h1.3c.2-.1.3 0 .4 0h.4v.3l-.4-.1h-2.5v-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M27 29.7h-2.3v.3l.3-.1.3-.1h.4l.4.2.3-.1.3-.1h.4l.3.2v-.2l-.3-.1Zm-.3-.1h.4l.3.1v.3h-.3l-.4-.2-.3.1-.3.1m.6-.4h-.3l-.3.1h-.4l-.4-.1H25l-.3.1v.3h.3l.3-.2.4.1.4.1",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "m24.7 30 .3-.1h.7a.8.8 0 0 0 .7 0h1.1v.3H27l-.4-.2-.3.1-.3.1h-.4a1 1 0 0 0-.7 0h-.4V30"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M26.4 30a.8.8 0 0 1-.7 0l-.4-.2-.3.1-.3.1v.2l.3-.1h2.4V30h-.3l-.4-.2-.3.1Zm-1.7 0 .3-.1.3-.1h.4l.4.2.3-.1.3-.1h.4l.3.2v.2h-.3l-.4-.1h-.3l-.3.1h-.4l-.4-.1H25l-.4.1V30Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005BBF",
    d: "M24.7 30.2h.3l.4-.2.3.1a.8.8 0 0 0 .7 0h.7l.4.1v.2H27l-.4-.1h-.3l-.3.1h-.4l-.3-.1H25l-.4.1v-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M27 30.1h-.6a.8.8 0 0 1-.7 0h-.4a1 1 0 0 0-.3 0l-.3.1v.2h.3l.3-.2.4.1h1.7l-.3-.2Zm-2.3 0h2.7v.3h-.3l-.4-.1h-.3l-.3.1h-.4l-.3-.1H25l-.4.1v-.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M24.7 30.6h.3l.4-.1h.3l.4.1h.3l.3-.1h.4l.4.1v-.2H27l-.4-.1h-.3l-.3.1h-.4l-.3-.1H25l-.4.1v.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m26.7 30.2.4.1h.3v.3h-.3l-.4-.1h-.3l-.3.1h-.4l-.4-.1H25l-.3.1v-.2h.3l.3-.2.4.1h1Zm-2 .4h.3l.3-.1h.4l.4.1h.3l.3-.1h.4l.3.1v-.2h-.3l-.4-.1h-.3l-.3.1h-.4l-.3-.1H25l-.3.1v.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005BBF",
    d: "M24.7 30.8h.3l.4-.1h.3l.4.1h.3l.3-.1h.4l.4.1v-.2H27l-.4-.1h-.3l-.3.1h-.4l-.3-.1H25l-.4.1v.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M26.7 30.5h.4l.3.1v.3l-.3-.1h-2.4v-.2h.3l.3-.1h.4l.4.1h.3l.3-.1Zm-2 .3h.3l.3-.1h.4l.4.1h.3l.3-.1h.4l.3.1v-.2h-.3l-.4-.1h-.3l-.3.1h-.4l-.4-.1H25l-.3.1v.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M26.8 28.9c0 .2.1.3.3.3h-2s.2-.1.2-.3h1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M25.3 28.9h1.5c0 .2.2.2.3.2h-2s.2 0 .2-.2Zm-.1.2h1.7a.3.3 0 0 1 0-.2h-1.6l-.1.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M25.3 28.7h1.5l.1.1h-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M25.2 28.8h1.6-1.5Zm0 0H27h-1.8Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M25 29.7h2v-.5h-2v.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M25 29.1h2.1v.6H25v-.6Zm0 0v.6h2v-.5h-2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "M27.2 26.9c.2 0 .4.2.4.3l-.2.1c-.2.1-.2.3-.2.4a.5.5 0 0 1 0-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M27.2 26.9a.5.5 0 0 0 0 .8v-.2l.2-.2h.1V27l-.2-.1Zm0 0a.5.5 0 0 0 0 .7c0-.2.1-.2.2-.3h.1V27l-.3-.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M25.3 28.6h1.5v-7.1h-1.5v7.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M25.3 21.4h1.5v7.3h-1.5v-7.3Zm0 0v7.2h1.5v-7.1h-.2v7.1-7.1h-.2v7.1-7.1h-1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "M23.8 24.2c.7-.3 1.5-.3 2.2-.2.9.1 1.6.5 1.5.8l.3-.8c0-.3-.7-.7-1.6-.9a5 5 0 0 0-.9 0c-.6 0-1.1 0-1.5.2v.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m25.3 23 .9.1 1.2.4c.2 0 .3.2.3.3l.2.2-.4.8-.1-.3-.3-.2-1-.3c-.8-.1-1.6 0-2.3.2v-1l1.5-.1ZM24 24.2c.6-.2 1.4-.3 2.1-.1.5 0 .8.2 1.1.3l.3.2.1.2.3-.7v-.2l-.4-.3c-.3-.1-.7-.3-1.2-.3a5 5 0 0 0-.9-.1c-.6 0-1.1 0-1.4.2v.8Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "M26.8 25c.4 0 .7 0 .7-.2s-.1-.3-.4-.5h-.3v.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m27.2 24.3.2.2.1.3-.2.2h-.5v-.7h.2Zm-.4 0v.7h.5l.2-.2v-.2l-.4-.2a5.2 5.2 0 0 0-.3 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "M25.3 24.5c-.2 0-.4 0-.5.2 0 .1.1.3.5.5v-.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m24.8 24.7.5-.2v.8l-.4-.4h-.1v-.2Zm.5-.2-.5.2.1.2.4.3v-.7Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "m27.7 26.4-1-.5-.6-.3c-.8-.4-1.4-.7-1.3-.9l-.1.7c0 .2.4.6 1.1.9l1 .4c.4.1.8.4.8.5v-.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M24.8 24.7v.1l.3.3 1 .5h.1l.6.3a4.5 4.5 0 0 1 .9.4v.1l-.1.8-.1-.1-.2-.1-.5-.3-.3-.1h-.2a6 6 0 0 1-1.3-.8l-.3-.2v-.2a10.8 10.8 0 0 1 0-.7Zm-.1.7v.1l.3.3.9.5a6 6 0 0 0 .6.2l.3.2a2.5 2.5 0 0 1 .7.4l.2-.7-.2-.2-.7-.3-.6-.2H26a6.2 6.2 0 0 1-1.2-.8v-.1a6.4 6.4 0 0 0 0 .6h-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m24.7 23.9.2-.7-.2.5-.2-.4h-.2l.3.6h.1Zm.6-.7H25v.6h.4-.2v-.6m.6.1h.2-.5.2v.5l.1-.5m.2.6h.2v-.2h.1v.3h.2v-.3l.1-.1v-.2h-.4l-.2.5Zm.3-.5.2.1c0 .1-.1.2-.2.1v-.2Zm.8.7v.2h.1v-.6l-.6.3h.5Zm-2.6-.4.2-.1v.2l-.2-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M17.1 18a.2.2 0 0 0 .2.2s.2 0 .2-.2h-.1l-.1-.1H17Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "M19.3 16.4c.6 0 1.1.1 1.5.3l1.3.2a2.7 2.7 0 0 1 1.7.7h-.2v.4l-.4.5-.2.1-.4.4h-.3v.2l-3-.3-3 .3V19H16l-.4-.4-.2-.1-.4-.5v-.3l-.2-.1.7-.5 1-.2h.6l.7-.2a4 4 0 0 1 1.5-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M19.3 16.5a4 4 0 0 0-1.5.2l-.7.2h-.6c-.4 0-.7 0-1 .2l-.7.5h.2v.4l.4.5.2.1.4.4h.3v.2l3-.3 3 .3V19h.3l.4-.4.2-.1.4-.5v-.3l.2-.1-.7-.5-1-.2c-.4 0-1 0-1.3-.2l-1.5-.2Zm-1.5.2a4 4 0 0 1 1.5-.3c.6 0 1.1.1 1.5.3l1.3.2a2.7 2.7 0 0 1 1.7.6l-.1.2v.3l-.5.5-.2.2-.4.3h-.3v.2l-3-.3-3 .3V19H16l-.4-.4-.2-.1-.4-.5v-.3l-.2-.2.7-.4 1-.2h.6l.7-.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M19.3 20.4a10.4 10.4 0 0 1-2.8-.4v-.2c1-.3 1.9-.4 2.8-.3a10.4 10.4 0 0 1 2.9.3.1.1 0 0 1 0 .2c-.8.2-1.8.4-2.9.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M16.5 19.8v.2c.7.2 1.7.3 2.8.3a10.4 10.4 0 0 0 2.9-.3.1.1 0 0 0 0-.2c-.8-.2-1.8-.3-2.9-.3-1 0-1.9 0-2.8.3Zm2.8-.4c-1 0-1.9.1-2.8.4v.1a.1.1 0 0 0 0 .1 10.4 10.4 0 0 0 5.6 0 .1.1 0 0 0 0-.2c-.7-.2-1.7-.4-2.8-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "M19.3 20.2c-1 0-1.9-.1-2.6-.3a10.8 10.8 0 0 1 5.2 0c-.7.2-1.6.3-2.6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M19.2 19.6v.6-.6Zm.2 0v.6-.6Zm-.4 0v.6-.6Zm.1 0v.6-.6Zm-.4 0v.6-.6Zm.1 0v.6-.6Zm-.4 0v.6-.6Zm.2 0v.6-.6Zm-.3 0v.6-.5Zm-.3.1v.4-.4Zm.1 0v.4-.4Zm.1 0v.5-.5Zm-.3 0v.4-.4Zm-.1 0v.4-.4Zm-.1 0v.4-.4Zm-.1.1v.3-.3Zm-.2 0v.2h-.1v-.2Zm0 0v.3-.3Zm-.1 0v.2h-.1v-.2Zm-.2 0v.2-.2Zm0 0v.2H17v-.1Zm-.2.1Zm2.7-.3v.6-.6Zm.2 0v.6-.6Zm.2 0v.6-.6Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M19.3 19.4c-1 0-1.9.2-2.8.4v-.3c-.1-.2-.3-.2-.3-.2.8-.2 2-.4 3.1-.4 1 0 2.1.1 3.1.4l-.2.2v.3c-.7-.2-1.8-.3-2.9-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M22.3 19.3a11.4 11.4 0 0 0-6 0l.2.2v.2l2.8-.3c-1 0-1.9.2-2.8.4v-.3l-.2-.2a11.5 11.5 0 0 1 6.2 0h-.1l-.2.2v.3c-.7-.2-1.8-.3-2.9-.3a10.8 10.8 0 0 1 2.8.2v-.2a.4.4 0 0 1 .2-.2Zm-6 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M19.3 19a11.2 11.2 0 0 0-3.2.3V19a12.2 12.2 0 0 1 6.4 0v.2c-.9-.2-2-.4-3.2-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M19.3 18.8c-1 0-2 0-3.1.3v.1c.8-.1 2-.3 3.1-.3 1.2 0 2.3.2 3.1.4h.1V19c-.8-.2-2-.4-3.2-.4Zm0 0a11.4 11.4 0 0 0-3.2.4.1.1 0 0 0 .2.1 11.4 11.4 0 0 1 6.1 0h.1V19c-.8-.2-2-.4-3.2-.4Zm2.5 1.2a9 9 0 0 0-5-.1 10.7 10.7 0 0 0 5 0Zm-2.5-.4a10.8 10.8 0 0 1 2.6.3 10.6 10.6 0 0 1-5.2 0c.7-.2 1.6-.3 2.6-.3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.5 19.2h.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M18.6 19.1v.2-.1Zm-.1.1v-.1h.1v.1a.1.1 0 0 1-.1 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "M19.3 19.3H19V19h.7v.2h-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M19 19.1v.2h.3-.3a.1.1 0 1 1 0-.2h.7v.2h-.4.3l.1-.1H19Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#058E6E",
    d: "M17.8 19.4h-.2v-.2h.5v.1h-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m18 19.1.2.1-.1.1h-.3l-.2.1h-.1a.1.1 0 0 1 0-.2.1.1 0 0 1 .1 0h.4Zm-.2.2h.3v-.1h-.5v.1h.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17 19.4v-.1h.2-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M17 19.3v.2l.1-.1v-.1Zm0 0h.2a.1.1 0 0 1-.2 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "m16.3 19.5.1-.1h.3l-.2.2h-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M16.4 19.4h.4l-.3.2h-.2l.1-.2Zm0 .1v.1l.3-.2h-.3v.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#058E6E",
    d: "M20.8 19.4h.2l.1-.1v-.1h-.5c-.1 0 0 .1 0 .1h.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M20.6 19.1h.4a.1.1 0 0 1 .1.2v.1h-.5l-.1-.2Zm.2.2h.3l-.3-.1h-.2v.1h.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20 19.2Zm1.5.2v-.1h.2-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M20 19.1v.2l.2-.1H20Zm0 .1a.1.1 0 0 1 .2 0 .1.1 0 0 1-.2 0Zm1.6.1h-.1v.2l.2-.1-.1-.1Zm-.1 0h.2a.1.1 0 0 1-.2 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "M22.3 19.5v-.1h-.4l.3.2h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m22.2 19.4.2.2h-.2l-.3-.2h.3Zm-.2 0 .2.2h.1v-.2H22Zm-2.7.2c-1 0-2 .2-2.7.4a10.4 10.4 0 0 1 5.4 0c-.7-.2-1.6-.4-2.7-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m17 17.2.2.1.2-.3a.7.7 0 0 1-.3-.6c0-.4.5-.8 1-.8.4 0 .7.1.9.3v-.2l-.8-.2c-.7 0-1.3.4-1.3.9a.8.8 0 0 0 .3.7l-.1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M18.2 15.5c.3 0 .5 0 .8.2v.2a1.5 1.5 0 0 0-1.6 0c-.2 0-.3.3-.3.5a.7.7 0 0 0 .3.6l-.2.4-.1-.2v-.1a.9.9 0 0 1-.2-.8c0-.2.1-.4.4-.6l.9-.2Zm-1 1.7v.1l.2-.3a.7.7 0 0 1-.3-.7c0-.2 0-.3.3-.5l.8-.2.7.2v-.1l-.7-.2c-.4 0-.7.1-.9.3-.2.1-.4.3-.4.6a.8.8 0 0 0 .3.6v.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M17.1 17.2a.9.9 0 0 1-.4-.7c0-.3.2-.5.5-.7a.8.8 0 0 0-.3.6.8.8 0 0 0 .3.7l-.1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M16.7 16.5a.9.9 0 0 0 .4.7v-.1a.9.9 0 0 1-.1-1v-.2l-.3.6Zm0 0c0-.3.2-.5.5-.7a.8.8 0 0 0-.2 1l.2.2v.3H17a.9.9 0 0 1-.4-.8Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M15 17.5a.8.8 0 0 1-.2-.5v-.4c.3-.4.9-.6 1.6-.6h.5v.1h-.5c-.7 0-1.2.3-1.4.6a.7.7 0 0 0 0 .6l.2.2-.2.4-.1-.1.1-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M15.4 16.2a1 1 0 0 0-.5.4v.4l.1.5-.1.3.3-.3a.7.7 0 0 1-.2-.8c0-.2.3-.3.5-.4l.9-.2h.5l-.5-.1c-.4 0-.7 0-1 .2Zm-.4 1.3a.8.8 0 0 1-.2-.5v-.4l.6-.5 1-.2h.5v.4h-1.4a1 1 0 0 0-.5.5.6.6 0 0 0 0 .6l.2.2-.2.4h-.2l.2-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M15.3 16.2a1 1 0 0 0-.4.4.8.8 0 0 0 .1 1l-.1.2a1 1 0 0 1-.2-.6c0-.4.2-.7.6-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M15.2 16.3a1 1 0 0 0-.3.3.8.8 0 0 0 .1 1l-.1.2a1 1 0 0 1-.3-.6c0-.4.3-.7.6-1Zm-.3.3a1 1 0 0 0 0 1.1v-.2a.8.8 0 0 1-.1-1v.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M19.3 15.4c.2 0 .3.1.3.3v.4l.2.8-.5.5-.5-.5.1-.7v-.5c.1-.2.3-.3.4-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M19 15.7v.4c0 .4 0 .7-.2.8l.5.5.5-.5-.1-.7v-.5c-.1-.2-.2-.3-.4-.3-.1 0-.3.1-.3.3Zm0 0c0-.2.1-.3.3-.3.2 0 .3.1.4.3v.4l.1.8-.5.5-.5-.5.1-.7v-.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M19.3 15.6h.2v.5l.1.8-.3.3-.3-.3.1-.7v-.5a.2.2 0 0 1 .2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m19.3 15.5.2.2v.4l.1.8-.3.3-.3-.3v-.8l.1-.4a.2.2 0 0 1 .2-.2Zm0 0a.2.2 0 0 0-.1.2v.4l-.2.8.3.3.3-.3-.1-.7v-.5l-.2-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M21.5 17.2v.1l-.3-.3a.7.7 0 0 0 .4-.6c0-.4-.5-.8-1.1-.8-.3 0-.6.1-.8.3v-.2l.8-.2c.7 0 1.2.4 1.2.9a.8.8 0 0 1-.3.7l.1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M19.7 15.7v.1l.8-.2.7.2c.2.2.4.3.4.5v.1a.7.7 0 0 1-.3.6l.1.3h.1V17a.8.8 0 0 0 .2-.7c0-.3-.1-.5-.4-.6-.2-.2-.5-.3-.8-.3-.3 0-.6 0-.8.2Zm.8-.2c-.3 0-.6 0-.9.2v.2c.3-.2.6-.3.9-.2.3 0 .5 0 .7.2.2 0 .3.3.3.5a.7.7 0 0 1-.3.6l.2.4.2-.2-.1-.1a.9.9 0 0 0 .2-.8l-.3-.6-1-.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M21.5 17.2a.9.9 0 0 0 .4-.7c0-.3-.2-.5-.5-.7a.8.8 0 0 1 .3 1l-.3.3.1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M21.4 15.8c.3.2.5.4.5.7a.9.9 0 0 1-.4.7v-.1a.8.8 0 0 0 .2-.7.8.8 0 0 0-.3-.6Zm.2.1a.8.8 0 0 1 .2.5.9.9 0 0 1-.3.7v.1a.8.8 0 0 0 .4-.7l-.3-.6Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M23.6 17.5a.8.8 0 0 0 .1-.9c-.1-.4-.7-.6-1.5-.6h-.5v.1h.5c.7 0 1.2.3 1.4.6v.3a.7.7 0 0 1-.2.5l.3.4v-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M21.7 16h.5l1 .1c.3.1.5.3.6.5v.4c0 .2 0 .4-.2.5a.8.8 0 0 0 .1-.9 1 1 0 0 0-.5-.4c-.3-.2-.6-.2-1-.2h-.5v.1h.5c.4 0 .7 0 1 .2.2 0 .3.2.4.4v.3m-.2.5Zm.4.3-.2-.3.2.3-.2.1-.2-.4a.7.7 0 0 0 .2-.8c0-.2-.3-.3-.5-.4l-.9-.2h-.4l-.1-.1m2 1.8v.1m0-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m23.4 16.2.3.4a.8.8 0 0 1 0 1v.2l.3-.6c0-.4-.3-.7-.6-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M23.4 16.3c.4.2.6.5.6.9 0 .2 0 .4-.2.6l-.2-.3.2-.5v-.4a1 1 0 0 0-.4-.3Zm.3.3.2.4c0 .2-.1.4-.3.5l.2.2.2-.5c0-.3-.1-.5-.3-.6Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m19.1 17 .2-.2.2.2c0 .1 0 .2-.2.2a.2.2 0 0 1-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M19.2 17a.2.2 0 0 0 .1.1h.2c0-.2-.1-.2-.2-.2l-.1.1Zm0 0 .1-.2.2.2c0 .1 0 .2-.2.2a.2.2 0 0 1-.2-.2Zm.1.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m19.1 16.7.2-.2c.1 0 .2 0 .2.2l-.2.1a.2.2 0 0 1-.2-.1Zm0-.4h.4l-.2.2-.1-.2Zm.1-.3h.2-.2Zm0-.2.1-.1h.1v.1h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M19.3 15.7v.1Zm0 0h.1v.2l-.2-.1Zm0 .3v.1-.1Zm-.1 0a.1.1 0 0 1 .2 0 .1.1 0 0 1-.2 0Zm.1.2-.1.1.1.2.1-.2Zm-.1.1.1-.1.2.1-.2.2-.1-.2Zm0 .4a.2.2 0 0 0 .1.1l.2-.1-.2-.2-.1.2Zm0 0 .1-.2c.1 0 .2 0 .2.2 0 0 0 .2-.2.2",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M19.3 18h.1a.4.4 0 0 0 .5.6.4.4 0 0 0 .4-.3V18v.2c0 .2.3.3.5.3a.4.4 0 0 0 .4-.4l.2-.2v.4a.4.4 0 0 0 .4.4c.2 0 .3 0 .4-.2v-.1.1c0 .2.1.3.3.3l.3-.1.3-.3v.1l-.3.4-.4.1-.2-.2a.6.6 0 0 1-.7 0 .6.6 0 0 1-.2-.3.7.7 0 0 1-1 0l-.4.1a.6.6 0 0 1-.6-.2.6.6 0 0 1-.5.3l-.4-.2a.7.7 0 0 1-1 0 .6.6 0 0 1-.6.4l-.3-.1s-.1.2-.3.2h-.4l-.3-.5v-.1l.3.3.4.1c.1 0 .2-.1.2-.3v-.1.1a.4.4 0 0 0 .4.2.4.4 0 0 0 .4-.6V18l.2.2c0 .3.2.4.4.4.3 0 .5-.1.5-.3V18v.2a.4.4 0 0 0 .5.3.4.4 0 0 0 .4-.6h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M19.2 18a.5.5 0 0 1-.4.6.5.5 0 0 1-.4-.3.5.5 0 0 0 0-.1c-.1.3-.3.5-.6.5a.4.4 0 0 1-.4-.5l-.1-.1v.3c0 .2-.2.4-.5.4a.4.4 0 0 1-.3-.2h-.1v.2l-.2.1H16l-.3-.1a2.7 2.7 0 0 1-.3-.3v.1a1.2 1.2 0 0 0 .1.2l.3.2h.1l.2.1.3-.2a.6.6 0 0 0 .6 0l.3-.3a.6.6 0 0 0 1 0 .6.6 0 0 0 1-.1.6.6 0 0 0 .9 0 .6.6 0 0 0 1 .1.6.6 0 0 0 .8.2l.3.3h.2a.8.8 0 0 0 .4-.3 1.8 1.8 0 0 0 .1-.2 2.2 2.2 0 0 1-.3.2.8.8 0 0 1-.3.1h-.2v-.3l-.5.2a.4.4 0 0 1-.4-.4V18h-.1a.5.5 0 0 1-.5.6c-.2 0-.4-.2-.5-.4a1.4 1.4 0 0 1 0-.1.5.5 0 0 1-.4.4.5.5 0 0 1-.5-.6h-.2Zm.1 0h-.1a.4.4 0 0 1-.4.5.4.4 0 0 1-.4-.2V18h-.1a.5.5 0 0 0 0 .2c0 .2-.2.3-.5.3a.4.4 0 0 1-.4-.4l-.1-.2-.1.2v.2a.4.4 0 0 1-.6.3l-.1-.1-.1-.2v.4l-.2.1H16l-.3-.1a2.7 2.7 0 0 1-.3-.3m3.8-.5h.2a.4.4 0 0 0 .4.5.4.4 0 0 0 .4-.2 2.3 2.3 0 0 1 0-.2v.1c.1.3.3.4.5.4a.4.4 0 0 0 .4-.4l.2-.2v.4a.4.4 0 0 0 .4.4c.2 0 .3 0 .4-.2v-.2.2l.1.2.2.1.3-.1a3 3 0 0 0 .3-.3v.1a2 2 0 0 1 0 .2l-.3.2-.2.1h-.2c-.1 0-.2 0-.3-.2a.6.6 0 0 1-.6 0 .6.6 0 0 1-.2-.3.7.7 0 0 1-1 0l-.4.2a.7.7 0 0 1-.6-.3.7.7 0 0 1-1 .1.7.7 0 0 1-1 0 .6.6 0 0 1-.5.4l-.3-.1c0 .1-.1.2-.3.2h-.4a1 1 0 0 1-.2-.3 2 2 0 0 1-.1-.1",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.4 18.5v-.1h-.2v.2h.2Zm-2-.3V18l-.2.1.1.2.1-.1Zm-2.2 0 .1-.2.1.1v.2l-.2-.1m-2 .3.1-.1h.2v.2h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M20.4 18v.3c-.1 0-.2 0-.2-.2l.2-.1Zm0 .2V18h-.1v.2l.1-.1Zm-2-.1h-.1v.2s.1 0 0-.2Zm-.2 0 .1-.1.1.1v.2l-.2-.1Zm4.1.2s.1.2 0 .2v.1c-.1 0-.2 0-.1-.1v-.1h.1Zm0 .1h-.1v.2h.2v-.2h-.2Zm-5.9 0h-.1v.2h.1v-.2Zm0 0a.2.2 0 0 1 .1.2h-.2v-.2h.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m17.1 17.3.2.2h.2v.3l-.1.1a.2.2 0 0 0-.2 0H17v-.2l-.2-.1h.2l.1-.4m0 1V18l-.1-.1h-.3l-.3.3h.4v.2l.2-.1.2-.1m.2 0V18l.1-.2h.2l.1-.1v.1l.3.1-.3.2.1.1h-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m17.1 17.3-.1.2a.2.2 0 0 0-.2 0l.1.2.1.2a.6.6 0 0 0-.2 0h-.2l-.2.3h.3v.2h.2l.1-.1a.6.6 0 0 0 .2-.1V18a.1.1 0 0 1 0-.1.2.2 0 0 1 .2 0v.2l.2.1h.3l.2-.3-.3-.1v-.1h-.3v.1-.4h-.1l-.3-.2Zm0 0v.3h-.2l.1.2.1.1a.2.2 0 0 1 .1 0 .2.2 0 0 1 .2 0v-.4l-.3-.2Zm0 .7a.9.9 0 0 0-.1 0l-.2-.1h-.1v.1s-.2 0-.2.2h.3v.1h.2a.5.5 0 0 0 .1-.1V18Zm.3 0v.1h.4l.3-.2h-.3v-.2l-.3.1v.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "m17 18 .3-.1.2.1-.2.2a.2.2 0 0 1-.2 0V18Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M17.2 18H17a.2.2 0 0 0 .2.2s.2 0 .2-.2h-.1l-.1-.1h-.1Zm-.1 0h.3v.1l-.1.2a.2.2 0 0 1-.2-.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m19.3 17 .2.3h.2l-.1.3-.1.1a.2.2 0 0 0-.2 0h-.1l-.1-.1-.1-.2v-.2l.2.1.1-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M19.3 17c.1 0 .2.1.2.3a.3.3 0 0 1 .2 0l-.1.3-.1.2a.2.2 0 0 0-.2-.1h-.1a.7.7 0 0 1-.1-.1l-.1-.2v-.2h.1l.2-.3Zm-.1.7a.2.2 0 0 1 .3 0v-.1l.1-.2v-.2a.2.2 0 0 0 0 .1h-.1c0-.1 0-.2-.2-.3l-.1.3H19l.1.3a.6.6 0 0 0 0 .1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M19.2 18v-.3H19l-.2-.1h-.1v.1c-.1 0-.2 0-.3.2l.3.1v.1h.3l.2-.1m.3 0a.2.2 0 0 0 0-.3h.1l.3-.1v.1c.2 0 .3 0 .4.2l-.4.1v.2l-.3-.1-.1-.1m2-.8-.2.3h-.1v.4a.2.2 0 0 1 .2 0h.2l.1-.2.1-.1h-.2v-.4m-.1 1V18l.2-.1h.3l.2.3H22v.2l-.3-.1-.1-.1Zm-.3 0v-.4H21l-.1-.1v.1l-.3.1.2.2v.1h.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m21.3 17.5.2-.3.1.3h.1a.2.2 0 0 1 .1 0v.2l-.1.2h.3l.2.3H22v.2a1 1 0 0 1-.4-.2v-.3a.2.2 0 0 0-.2 0v.2l-.2.1h-.4l.1-.1a.5.5 0 0 1-.3-.2l.3-.1v-.1a15 15 0 0 0 .4 0v-.2h.1Zm-.1 0v.3a.2.2 0 0 1 .2 0l.1.1h.1l.1-.3h-.1v-.3c-.2 0-.2.1-.3.2h-.1Zm.4.5v.2l.1.1h.1l.4-.1-.3-.2v-.1h-.2a.5.5 0 0 0-.1 0Zm-.4 0a.5.5 0 0 0 0-.2h-.3l-.3.1.2.2h.4v-.2Zm-1.2-.5v.1l.3.3-.3.1v.2l-.3-.1a.8.8 0 0 1-.1 0V18a.2.2 0 0 0 0-.2.6.6 0 0 1 .1-.2h.4Zm-.5.3a.2.2 0 0 1 0 .2.9.9 0 0 0 .1 0l.3.1V18l.4-.1-.4-.2v-.1h-.3a.5.5 0 0 0-.1.2Zm-.9-.3h.2l.2.1a.5.5 0 0 1 .2.1v.3a1.2 1.2 0 0 1-.2.1h-.4l-.2-.2.3-.2v-.2Zm.6.5a1.3 1.3 0 0 1-.2 0l-.2.1h-.1V18l-.3-.1.3-.2v-.1h.3a.5.5 0 0 1 .1.1v.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "m21.2 18 .2-.1.2.1a.2.2 0 0 1-.2.2.2.2 0 0 1-.2 0 .2.2 0 0 1 0-.2Zm2.2.4h-.2v.3h.1c0-.1.1-.2 0-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M21.3 18h-.1a.2.2 0 0 0 .2.2.2.2 0 0 0 .2-.2h-.1l-.1-.1h-.1Zm-.1 0h.3v.1a.2.2 0 0 1-.1.2.2.2 0 0 1-.2-.2Zm2 .4h.2-.2v.3h.1v-.2h.1v.2H23v-.2l.2-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m23 18.6.2-.1s.1-.1.2 0c0 0 0-.2.2-.3h.3a.3.3 0 0 0-.3-.3.3.3 0 0 0-.2.1h-.2v.4-.1l-.3-.2h-.1l-.3.1c0 .1 0 .2.2.2v.1h-.1.5m-7.5 0h-.1s-.2-.1-.2 0l-.2-.3h-.4a.3.3 0 0 1 .3-.3l.2.1h.2v.4l.1-.1.2-.2h.2l.3.1-.2.2v.1h-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m15.3 17.9.2.2v.2l.2-.2h.2l.3.1-.2.2.1.2h-.5l-.1-.1h-.2m0-.6Zm0 0Zm8.1 0a.3.3 0 0 1 .2 0 .3.3 0 0 1 .3.3.8.8 0 0 0-.1 0h-.2l-.1.2h-.1m0-.5-.2.2v.2l-.3-.2h-.1l-.4.1.3.2h-.1v.1l.3.1h.2v-.1h.2m-.2 0h.1a.9.9 0 0 0 0-.2l-.3-.2v.1h-.4l.2.2v.1h.4Zm.3-.6Zm-8.5 0h.3m-.3 0Zm0 0-.2.2.1-.1Zm-.2.2Zm0 .1",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "M15.3 18.4h.2v.3h-.2v-.2m3.8-.6.2-.2c.1 0 .2 0 .2.2 0 0 0 .2-.2.2a.2.2 0 0 1-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m19.3 17.7-.1.2a.2.2 0 0 0 0 .1h.2l.1-.1c0-.1 0-.2-.2-.2Zm0 .4h.2v-.2c0-.1 0-.2-.2-.2 0 0-.2 0-.2.2m-3.8.6v.1h.2v-.1h-.2Zm0 0c0-.1.1-.1.2 0s0 .2 0 .2h-.2v-.3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005BBF",
    d: "M19 15c0-.2.1-.3.3-.3.2 0 .4.2.4.4s-.2.3-.4.3a.4.4 0 0 1-.4-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M19 15a.4.4 0 0 0 .3.4c.2 0 .4-.1.4-.3 0-.2-.2-.4-.4-.4s-.4.2-.4.4Zm-.1 0c0-.2.2-.3.4-.3.3 0 .4.1.4.4 0 .2-.2.3-.4.3a.4.4 0 0 1-.4-.3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M19.2 14v.2H19v.2h.2v.6H19v.2h.8V15h-.3v-.6h.3v-.2h-.3V14h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M19.2 14v.2H19v.2h.2v.6h-.3v.2h.8V15h-.3v-.6h.3v-.2h-.3V14h-.2Zm0 0h.2v.2h.2v.2h-.2v.6h.3v.2H19V15h.2v-.7H19v-.2h.2V14Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M19.4 31a8 8 0 0 1-3.4-.8 2.1 2.1 0 0 1-1.2-1.9v-3h9v3a2.1 2.1 0 0 1-1.1 2c-1 .4-2.2.7-3.3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M14.8 25.3h9v3a2.2 2.2 0 0 1-1.1 2 7.7 7.7 0 0 1-6.7 0 2.2 2.2 0 0 1-1.2-2v-3Zm4.6 5.7a8 8 0 0 0 3.3-.8 2.1 2.1 0 0 0 1.1-1.9v-3h-9v3a2.1 2.1 0 0 0 1.2 1.9c1 .5 2.2.8 3.4.8Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M19.3 25.3H24v-5h-4.6v5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M19.3 20.3H24v5h-4.6v-5Zm0 0v5h4.5v-5h-4.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "M19.3 28.3c0 1.2-1 2.2-2.2 2.2-1.3 0-2.3-1-2.3-2.2v-3h4.5v3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M15.8 30c.1.2.3.3.5.3v-5.1h-.5v4.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M15.8 25.2h.6v5.2l-.6-.3v-5Zm0 0v4.9l.5.2v-5h-.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M14.8 28.3c0 .5.2 1 .5 1.4v-4.5h-.5v3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M14.8 25.2h.5v4.5a2.3 2.3 0 0 1-.5-1.4v-3Zm0 3c0 .6.2 1 .5 1.4v-4.3h-.5v3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7B500",
    d: "M16.8 30.4h.5v-5.2h-.5v5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M16.8 25.2h.6v5.3h-.6v-5.3Zm0 5.2v-5.2h.5v5.2h-.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m17.8 30.3.6-.2v-4.9h-.6v5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M17.8 25.2h.6v5l-.6.2v-5.2Zm0 0v5.1l.5-.2v-4.9h-.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "M14.8 25.3h4.5v-5h-4.5v5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M14.8 20.3h4.6v5h-4.6v-5Zm0 0v5h4.5v-5h-4.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M18.8 29.6c.3-.2.5-.6.6-1.1v-3.3h-.6v4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M18.8 25.2h.6v3.3l-.2.7-.3.4v-4.4Zm0 4.4c.2-.1.3-.3.3-.4l.2-.7v-3.3H19v4.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M14.8 25.3h4.6v3-3h-4.6v3c0 1.2 1 2.1 2.3 2.1 1.2 0 2.2-1 2.2-2 0 1.1-1 2-2.2 2-1.3 0-2.3-.9-2.3-2.1v-3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "M23.9 25.3v3c0 1.2-1 2.2-2.3 2.2-1.2 0-2.3-1-2.3-2.2v-3H24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M19.3 25.3H24v3c0 1.2-1 2.2-2.3 2.2-1.2 0-2.3-1-2.3-2.2v-3Zm4.5 0h-4.4v3c0 1.2 1 2.1 2.2 2.1 1.2 0 2.2-1 2.2-2v-3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m20.2 27.6-.1.1H20v-.1h-.2a.2.2 0 0 0 .2.2v.4h.1v-.4a.2.2 0 0 0 .2-.1h.4v-.1h-.5m2 0h-.4v.1l.4.5v.1l-.5-.5v.9h-.2v-.9l-.5.5.4-.6H21v-.1h1.2Zm-1.8 0h.4c0 .2.1.2.2.2v.4h.1v-.4a.2.2 0 0 0 .2-.2h-.2v.1H21v-.1h-.6Zm-.6 2h.4l-.4.2a.2.2 0 0 1-.2.2.2.2 0 0 1-.3-.2l-.4-.1v-.1h.4a.2.2 0 0 1 .2 0v-.7h.1v.6c.1 0 .2 0 .2.2Zm-.4-2.2-.1.1-.3-.3h-.3a.2.2 0 0 1 0-.4l-.1-.4h.1l.1.3h.2l.4-.4v.1l-.3.5v.2l.3.3Zm-.6-.5h.2v.1a.1.1 0 0 1-.2 0Zm-.2-.4h-.1V26v.1l.1.3Zm.1-.5h.2v.4h-.1V26Zm.6 1.3.4.2v-.1l-.3-.2h-.1Zm-.1.1.4.3-.4-.1v-.2Zm.2-.9.1.1.3-.3v-.1l-.4.3Zm-.1 0-.1-.2.3-.3h.1l-.3.4Zm1.7.9v.1c.2 0 .3-.2.4-.3h.2a.2.2 0 0 0 0-.4l.2-.4h-.2v.3h-.2l-.4-.4-.1.1.4.5a.2.2 0 0 0 0 .2l-.3.3Zm-1.2-.6a.1.1 0 0 0-.1 0v.2a.1.1 0 0 0 .1 0v-.1Zm.2-.4h.2V26h-.1v.4Zm0-.4h-.2v.5h.2V26Zm-.5 1.3-.5.2v-.1l.4-.2v.1Zm0 .1-.4.3h.1l.4-.1v-.2Zm-.2-.9-.1.1-.3-.3.1-.1.3.3Zm.2 0v-.2l-.2-.3H19l.4.5Zm-2-.9.1.2h.5v-.2h-.5Zm2 0v.2H19v-.2h.5Zm-1 2h.2l-.1.2a.1.1 0 0 1-.1-.1Zm1.7-2.3h.1v-.5h-.1v.5Zm-.2 0h-.1v-.5h.1v.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m19.8 27.6.2-.2v-.5h.1v.5c.1 0 .2 0 .2.2h.4-.5a.1.1 0 0 0-.1 0h-.3Zm1.2 0h.4l-.5-.6.1-.1.5.5v-.7h.2v.7l.4-.5h.2l-.5.6h.4H21Zm.9 0h.3c0-.1 0-.2-.2-.2v-.5.5c-.1 0-.2 0-.2.2h-.4.6m-3-1.4.6.6h.1l-.6-.7h.5v-.2h-.4a.2.2 0 0 0-.3-.2.2.2 0 0 0-.2.3.2.2 0 0 0 .2.2v.5h.1v-.5Zm5.9 1.4v.5h-.2v-.5l-.6.6H24l.6-.7H24v-1.6h.4a.2.2 0 0 1 .3-.2.2.2 0 0 1 .2.3.2.2 0 0 1-.2.2v1.4Zm-1.6 0v.3h-.1v-.3a.2.2 0 0 1-.2-.2h-.3V26h.3a.2.2 0 0 1 .3-.2s.2 0 .2.2h.4v.1h-.4a.2.2 0 0 1-.2.2v1.4Zm-1.6.4h-.2v.4h.2V28Zm.1 0h.2v.4h-.2V28Zm2.9 0h-.2v.4h.2V28Zm.1 0h.2v.4h-.2V28Zm-2.3 0h.1l.3.3-.1.1-.3-.4Zm-.2.1v.2l.2.3.2-.1-.4-.4Zm1.8 0-.2-.1-.3.3.1.1.4-.4Zm0 0 .2.1-.3.4-.1-.1.3-.4Zm-1.8.9v-.2h.4v.2h-.4Zm-.7-1.6.2-.1v.2a.1.1 0 0 1-.1 0 .1.1 0 0 1 0-.1Zm1.2.6v.2h-.5V28h.5Zm0-.1v-.2h-.5v.2h.5Zm1.5 1.7v-.2h-.5v.2h.5Zm.4-1.6.1-.1v.2a.1.1 0 0 1-.1-.1Zm-3.4 0h.2l-.1.1a.1.1 0 0 1-.1 0Zm.6.1v.2h.5V28H22Zm0-.1v-.2h.5v.2H22Zm-.6.4h-.1v.5h.1v-2.6m.2 0h.1v.5h-.1v-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    fillRule: "evenodd",
    d: "M20 25.7a.3.3 0 0 1 .3.2h.4v.1h-.4l.6.7-.2.1-.5-.6v.5H20v-.5a.2.2 0 0 1-.2-.3.3.3 0 0 1 .3-.2Zm.2.5.5.6h.1l-.5-.7h.4v-.2h-.4a.2.2 0 0 0-.2-.2.2.2 0 0 0-.2.3.2.2 0 0 0 .1.2v.4h.1v-.4Zm1.3.5h.2v.7l.4-.5h.2l-.5.6h.4v.2h-.4l.5.5-.2.2-.4-.5v.8h-.2v-.8l-.1.1v.2h-.2v.7h.1v.7a.2.2 0 0 1 .2 0v-.4a.1.1 0 0 1-.1-.2h.1v-.1h.2v.6l.1.1h.4l-.4.2a.3.3 0 0 1-.2.2m.2-.3-.1-.2V29h-.2l.1.2v.4a.2.2 0 0 0-.2.1h-.2v.2h.2a.2.2 0 0 0 .2.2.2.2 0 0 0 .2-.2l.4-.1v-.1h-.4Zm-.6 0-.2-.1.2.1Zm0-.1v-1.4l-.2.2v-.2l.2-.3a.2.2 0 0 1-.2-.2v-.2l.2-.1-.3-.4.1-.1.2.2v-.2h.2v.5-.7m0 .5V27h-.2v.2l.1.1Zm-.2 0h.1v.2c.1 0 .2 0 .2.2h.4-.4a.2.2 0 0 1-.1.2v.2l-.2.1V28l.2-.1v-.1H21v-.1h.3l-.2-.3v-.2Zm0 0-.2-.3v.1l.2.3V27Zm0 .2-.1.1h.2v-.1Zm-.2.2Zm0 .1a.2.2 0 0 0 .2.1v.1l.2-.2H21Zm.2.3-.2.2v.1l.2-.1V28Zm0 .2h.1V28v.2Zm.2-.2v-.2h.1v.8h.2v-.8l.4.5h.1l-.4-.6h-.3a.3.3 0 0 1-.1.2Zm.5-.3h.3v-.1h-.3Zm-.1-.2h-.3l-.1-.1v-.1.1h.1v-.7h.2v.7l.4-.5h.1l-.4.6Zm-.6 1.4v.4-.4Zm0 .4h.1a11.3 11.3 0 0 1 0-.2v-.2.4Zm0-.2h.1Zm.3 0V29v.1Zm0-.1v.1-.1Zm-.5-.2v.5h-.2V29h.2Zm0 .5V29h-.2v.4h.2Zm1 .7h.1v.4h-.2l.1.1v.1h-.3v.2l.3.2v.2h-.1l-.3-.3h-.3a.2.2 0 0 1 0-.4l-.1-.5h.2v.4h.1v-.1h.2V30h.2Zm-.2.1h-.1.1Zm0 .1h.2-.2Zm0 0-.1.1h.2-.1Zm0 .2h-.2v.1h.2Zm0 .1.1.1h.1l-.2-.2v.1Zm0 0h-.3v-.1l-.2-.4v.5a.2.2 0 0 0 0 .3h.3l.3.3c0-.2-.1-.2-.2-.3v-.3Zm-.2-.1v-.1Zm.3-.1h.2l-.1-.1Zm0-.1V30h.2l-.1.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    fillRule: "evenodd",
    d: "M24 25.7a.2.2 0 0 0-.3.2h-.4V27h.3v-.4h.1v.4l-.4.5h.2l.3-.4V27h.2v-.7a.2.2 0 0 0 .2-.2.2.2 0 0 0-.3-.3Zm0 1.7.2.2a.2.2 0 0 1-.2.3V29h.2v.4H24l-.1.4a.2.2 0 0 1 0 .3h-.3c0 .2-.2.3-.3.4l-.1-.2.3-.2a.2.2 0 0 1 0-.3l-.4-.4.1-.1.4.4h.1l.1-.2-.2-.1V29h.3v.3V28l-.2-.2h-.4v.1l-.2-.1.6-.7h-.4V26h.4a.3.3 0 0 1 .2-.2.3.3 0 0 1 .3.2.2.2 0 0 1-.2.3v1.2Zm-.3-.4v-.4h-.1v.4Zm-.3.7h.3l.2.1v.4-.4h.1a.2.2 0 0 0 .2-.2l-.2-.2v.3h-.2v-.3l-.1.2h-.3Zm0-.1h-.1.1Zm0 0h.3l.1-.2v-.2l-.3.3Zm.5 0V27v.7Zm-.6.1h-.1v-.1.1h.1Zm.7 1.7h-.1l-.1.4h-.2l-.4-.4v.1l.3.4a.2.2 0 0 0 0 .3l-.3.2v.1l.4-.2.3-.1a.2.2 0 0 0 0-.2v-.5Zm0 .1V29h.1v.4H24Zm-.2 0v-.4h-.1v.2a1.6 1.6 0 0 0 0 .2h.1Zm-.1-.2Zm-1.4-3.6c-.1 0-.2 0-.3.2h-.3v3h.3a.2.2 0 0 0 .2.1v.3h.1v-3.1a.2.2 0 0 0 .2-.2h.4-.4l-.2-.2Zm-.3.2.3-.2s.2 0 .2.2h.4v.1h-.4a.2.2 0 0 1-.1.2v3.2h-.2V29a.3.3 0 0 1-.2-.2h-.4v-3h.4Zm-1.1 4v-.4.4Zm0-.5h.1v.5h-.2v-1.5l-.1.1-.1-.1.2-.3v-1.6 1.6h.2l-.1.2v.2l.2-.3.2.2-.3.3h-.1v.7Zm0-.8.3-.2v-.1l-.3.3Zm0-.3.1-.2h-.1v.2Zm0-.2-.3.3h.2V28Zm-.8-.6-.1.1v.1h.2l-.1-.2Zm-.1.1h.2l-.1.1a.1.1 0 0 1-.1 0Zm.7 1.8v.5h-.2v-.5h.2Zm0 0h-.2v.4h.2v-.4Zm3 .6h.1a.1.1 0 0 1 0 .1.1.1 0 0 1-.2 0 .1.1 0 0 1 0-.1Zm0 0a.1.1 0 0 0 0 .1V30Zm-.6 2.1v.1l-.4.3v-.2l.4-.2Zm0 .1-.4.1v.1c.2 0 .3 0 .5-.2Zm-.3.4c.2 0 .3-.2.4-.3l.1.2-.4.2-.1-.1Zm.4-.2-.4.2h.5v-.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    fillRule: "evenodd",
    d: "M25.5 22.7h-.1v.1h.1v-.1Zm-.1 0a.1.1 0 0 1 .2 0m-.1.2a.1.1 0 0 1-.1-.1M24 25.3h.1v.5H24v-.5Zm-.2 0v.5h-.2v-.4h.2Zm-.1 0v.5h.1v-.4h-.1Zm.3 0v.5h.1v-.4H24Zm-1 .3h.5v.2H23v-.2Zm.1 0v.1h.4-.4Zm-.5.1-.1.1v.1-.2Zm-.1.1a.1.1 0 0 1 .2 0l-.1.1a.1.1 0 0 1-.1 0ZM20 26v.1h.1V26Zm0 0h.2v.1H20a.1.1 0 0 1-.1 0Zm3.1 0h.6v.2h-.5V26Zm0 0v.1h.5-.4Zm-.5.3h-.2v.5h.2v-.4.5l-.3.4-.2-.1.4-.4v-.5Zm-.1.5-.3.4h.1l.3-.3h-.1Zm1.3-.4h.5v.2h-.9v-.1h.4v-.1Zm0 .1h-.4v.1h.5-.1Zm0 0h.4-.3Zm0 0Zm-1 0h.1v.4h-.2v-.5Zm0 0v.4-.4Zm.4.1v.6l.1-.1v-.4h-.1Zm.1.1h-.1v.4h.1v-.4Zm-1 0h.1l-.4.4V27l.2-.4Zm0 0-.3.3.4-.3h-.2Zm-1.4 0 .3.3v.1l-.4-.4h.1Zm-.1 0 .3.4V27l-.2-.3h-.1Zm3 0h.5v.2h-.9v-.1h.4v-.1Zm0 .1h-.4v.1h.4v-.1Zm0 0h.1-.1.5-.4Zm0 0Zm-3.1 0 .3.4h-.2l-.3-.2.2-.2Zm0 0-.1.1.2.3h.2l-.3-.4Zm0 .7h.4v.2h-.5v-.2Zm0 0v.1h.4-.4Zm-.1.3h.5v.2h-.5v-.2Zm0 0v.1h.5-.5Zm1.7.3.3.4-.1.1-.4-.4h.2Zm-.1.1.3.4v-.1l-.2-.3h-.1Zm4 0v.1h.1Zm0 .1v-.1l.2.1-.1.1a.1.1 0 0 1-.1 0v-.1Zm-4.2 0 .4.4h-.2l-.3-.2.1-.2Zm0 0v.1l.2.3h.1l-.3-.4Zm.8.5v.1h.1v-.1Zm0 0h.2v.2a.1.1 0 0 1-.2 0 .1.1 0 0 1 0-.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#058E6E",
    d: "M21.3 27.6a.2.2 0 0 1 .5 0 .2.2 0 0 1-.2.3c-.1 0-.3-.1-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB4446",
    d: "M21.6 21.5h-.2l-.2-.2h-.1c-.1-.1-.2 0-.2 0h.1c0 .2.2.2.2.2h.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M21 21.2h.2v.1l.2.1h.3v.1h-.4a1.6 1.6 0 0 1-.2 0l-.2-.1a.4.4 0 0 0-.1-.1Zm-.1 0a.5.5 0 0 1 .1.2h.2v.1h.4-.2l-.2-.2H21a.3.3 0 0 0-.2 0Zm0 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ED72AA",
    d: "M22.3 21.3v.5-.1.2l.1.1v.1l-.2-.1v.3-.1L22 22v.4l-.2-.2.1.1s0 .3.2.5c0 0 .2.3.5.2.3 0 .1-.4 0-.6v-1l.1-.2V21h.2v.2-.2l.3-.1v.2l-.2.2h.2l-.2.1v.2l-.2.1v.5l.1.5-.1.4-.3.1-.1.3v.2h.2v.4l-.1.2v.2h-.4v-.2s-.1 0 0 0h.2V24h-.1v-.2.2h-.1v-.2.2H22v-.2c-.1 0-.1 0 0-.1v-.1h-.4v.5h-.5v.1H21V24h-.1s-.1-.1 0-.1v-.1h.1v-.1h.1c0 .2.1.2.2.2h.1v-.4h-.1v.2-.4l.1-.1h.5l-.4-.2-.2-.2v-.2h-.1l-.1.2v-.1l-.2.1-.1.1v-.1h-.3v.2h-.4v-.2h.2l-.1-.1v-.1s0-.1 0 0h.5l.2-.1h.1v-.2h-.2l-.1-.1h-.2l.2-.1h-.1l-.2-.1h.2l-.1-.1v-.1h-.2v-.1l-.1-.1h.1l-.1-.2s0-.1.1 0h.1v-.2h.2v.5h.2l.2.2h.5v-.3h.2v-.3h-.2V21h.2l.2-.1.2.1.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M23.3 21h-.1l-.1.1a.2.2 0 0 0-.1.2V21h-.1v.2l-.1.2a.7.7 0 0 0 0 .3v.1a3 3 0 0 0 0 .2v.9l-.1.2-.4-.1-.1-.2a.9.9 0 0 1-.2-.5h.1v-.1a.5.5 0 0 0 0-.2m0 0v.4a.9.9 0 0 0 .1.4l.2.2h.4v-.6l-.1-.4v-.5l.1-.2V21l.2.1h.2a.9.9 0 0 0 0-.1h.1v.2l-.2.1h.2v.1l-.2.1v.2l-.2.1v.5a8.4 8.4 0 0 1 .1.5l-.1.4-.2.1a.8.8 0 0 0-.1 0l-.1.3v.2h.1l.1.1v.2l-.1.3a.6.6 0 0 0 0 .1v.1h-.1v.1h-.1v-.1h-.2a.2.2 0 0 1 0-.1v-.2H22h.2V24h-.1a.4.4 0 0 1-.1 0l-.2-.1v-.2h-.2v.2a3.6 3.6 0 0 0 0 .2h-.5v.1H21a.1.1 0 0 0 0-.1h-.1V24h-.1v-.1h.1v-.1l.1-.1h.1l.1.1h.2v-.2l-.1.1v-.4l.1-.2h.4a8.6 8.6 0 0 1-.3-.2l-.2-.2v-.1H21l-.1.2v-.1l-.2.2v-.1h-.2v.1h-.1a.1.1 0 0 0-.1 0h-.1a.2.2 0 0 1 0-.1v-.4h.1c.1.1.2.1.2 0l.3-.1h-.1v-.1l-.2-.1m.9-1h.1l.1-.1a.6.6 0 0 1 .1-.1 1.2 1.2 0 0 1 .1 0 1.6 1.6 0 0 1 .4.3v.7h-.1v.2m0 0v.1l.1-.2h.1v-.2h-.1v-.1h.1v-.5a1.4 1.4 0 0 0-.5-.3 1.6 1.6 0 0 0-.2 0h-.2l-.1.1a.4.4 0 0 0 0 .1v.1h.1l.1.1v.1h-.1l-.1.1v.2h-.2a2.6 2.6 0 0 1-.2 0 1.1 1.1 0 0 1-.2 0 1.6 1.6 0 0 0-.1-.1h-.1v-.1h-.1v-.3h-.1v.1h-.1v-.1h-.1l-.1.1v.4h.2v.1h.1m0-.5Zm0 1.6h.1v-.1h.2v-.1h.2l.1-.1v.1l.2-.1h.1a.9.9 0 0 0 .4.4 9.3 9.3 0 0 0 .2 0l-.2.1h-.3l-.1.1v.5-.2.2h.1v.2H21v-.1h-.2a.2.2 0 0 0 0 .1h.1v.1h-.1v.1h.1v.1l.1.1V24h.4m.8.3Zm1-3.2a.3.3 0 0 0 0-.2m-.7 3.5v.1h-.4v-.3h.1l.1-.1V24l-.1-.1h-.1m1-3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M21.4 21.3v-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M21.4 21.2Zm0 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m21.8 21.1.1.1h-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m21.7 21 .1.1a.4.4 0 0 1 .1.1h-.1V21Zm.2.2-.1-.1.1.1Zm.3.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB4446",
    d: "M20.4 21.2h.1v-.1l-.1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m20.4 21 .2.2v.1h-.1a.2.2 0 0 1-.1 0V21Zm0 .2h.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB4446",
    d: "M20.2 21.3h-.3.1v.1h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M20.2 21.3v.1h-.3a.2.2 0 0 1 0-.1h.2Zm-.2 0v.1h.1v-.1H20Zm0 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB4446",
    d: "M20 21.6v.2h.1v-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M20 21.6h.1v.2H20v-.1a.2.2 0 0 1 0-.1Zm0 .2h.1v-.1H20Zm1.4-.3v.1Zm0 .1Zm.1-.1v.1Zm0 .1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M21.4 21.3h.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M21.4 21.3v.1h.1v-.1Zm0 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M21.5 21.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M21.5 21.3h.1v.1h-.1Zm0 0Zm-.5.6v.1h.3a.5.5 0 0 0 0 .1v.2h.1l.1-.2v.4l.1-.1v-.1h.1l.1.2v-.1h.1v-.1.4l-.2-.2-.2.1v.1h-.2.1l.1-.1v-.2l-.2.1H21l.1-.1H21v.1-.1h.1v-.1h.1V22h-.4l.1-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB4446",
    d: "M20.3 22.5h-.2l.1.1h.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M20.3 22.5a.1.1 0 0 0-.1 0H20v.1h.2Zm-.2 0a.1.1 0 0 1 .1 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB4446",
    d: "m20.2 22.8-.1.1h.1v-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M20.2 22.8v.2a.1.1 0 0 0-.1 0 .2.2 0 0 1 0-.1.2.2 0 0 1 .1-.1Zm0 .1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB4446",
    d: "M20.4 23v.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M20.4 23h.1v.2h-.1V23Zm1.5.2h.1v.4-.4a.7.7 0 0 0-.1 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB4446",
    d: "M21 23.7h-.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M20.8 23.6h.2v.2h-.1a.2.2 0 0 0-.1 0v-.1Zm0 0v.1h.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB4446",
    d: "M20.8 24h-.1.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M20.8 24h-.1v.1h.1V24Zm0 0h-.1a.2.2 0 0 1 .1 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB4446",
    d: "M21 24.2v.1h.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M21 24.2h.2a.5.5 0 0 0-.1 0v.2H21v-.2Zm0 0v.1h.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB4446",
    d: "m22.1 24.3-.2.1h.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M22.1 24.3v.2h-.2a.6.6 0 0 1 0-.1l.1-.1a.2.2 0 0 1 .1 0Zm-.1 0h.1-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB4446",
    d: "M22.2 24.6v.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M22.2 24.6h.1v.1h-.1v.1-.1c-.1 0 0 0 0 0a.2.2 0 0 1 0-.1Zm0 0v.1-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB4446",
    d: "m22.4 24.7.2.1v-.1h-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M22.5 24.6h.1m0 0h-.1Zm0 0h-.1v.2-.1Zm0 .2h-.1v-.1m0 .1v-.1",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD691",
    d: "M19.6 29.7c.2 0 .3.2.3.3 0 .2-.3.4-.5.4-.3 0-.5-.2-.5-.4 0-.1 0-.3.3-.3l-.1-.1h.2v-.1h.1v.1h.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M19.4 29.5h.2a.2.2 0 0 1 0 .1l.2.2v.2c0 .3-.1.4-.4.4-.3 0-.5-.1-.5-.4 0-.1 0-.3.2-.4h.2a.2.2 0 0 1 0-.1Zm0 0-.1.1h-.1c-.2.1-.3.3-.3.4 0 .2.2.4.5.4.2 0 .4-.2.4-.4v-.2l-.2-.1v-.1h-.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#058E6E",
    d: "m19.3 30.6-.5-.3h-.5l.2.2.3.1h.6m0 0 .5-.2h.6l-.1.1-.4.2h-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M18.5 30.3h.5a2.7 2.7 0 0 1 .3.3 6 6 0 0 1-.1 0 1 1 0 0 1-.4 0 1 1 0 0 1-.3-.1 1 1 0 0 0-.2-.1h.2Zm-.1 0a1.4 1.4 0 0 1 0 .2h.2l.2.1a1 1 0 0 0 .5 0 4.6 4.6 0 0 0-.5-.2h-.3a4 4 0 0 0-.1 0Zm1.5.1-.3.1v.1h.4a.7.7 0 0 0 .3-.1h.1l-.5-.1Zm-.5.2a1.1 1.1 0 0 1 .5-.2 1.3 1.3 0 0 1 .6 0l-.1.1-.4.2h-.6Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "M19.4 30.4a.4.4 0 0 1 0-.7.5.5 0 0 1 .1.3.5.5 0 0 1-.1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M19.4 29.7a.5.5 0 0 1 .1.3.5.5 0 0 1-.1.4.5.5 0 0 1 0-.7Zm0 0a.4.4 0 0 0 0 .6.4.4 0 0 0 .1-.3.4.4 0 0 0-.1-.3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#058E6E",
    d: "M19.3 30.8v-.4h.1v.4h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M19.3 30.4h.1a1 1 0 0 1 0 .2v.2h-.1a1 1 0 0 0 0-.2v-.2Zm0 .4h.1v-.2a.7.7 0 0 0 0-.2v.2a.7.7 0 0 1 0 .2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m23.8 17.9.1-.1h.1-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M23.8 17.9a.1.1 0 0 0 .2 0v-.1h-.2v.1Zm0 0h.2v-.1h-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24 17.6h.1v.1H24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M24 17.7h.1v-.1h-.2Zm0-.1v.1h.1v-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m24 17.4.1-.1h.1v.2H24v-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m24 17.3.1.1h.1v-.1H24Zm0 0h.4v.1H24v-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24 17h.2-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M24 17a.1.1 0 0 0 .2.2v-.3H24v.2Zm0 0h.2-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24 16.8v-.1h.2l-.1.2-.1-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M24 16.8h.2v-.1H24v.1Zm0 0h.2-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.8 16.5h.2-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M23.8 16.5a.1.1 0 0 0 .1.1h.1v-.2h-.2v.1Zm0 0h.2-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m23.6 16.3.1-.1h.1v.2l-.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M23.7 16.2v.2-.1Zm0 0h.1v.2a.1.1 0 0 1-.2-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.4 16.1v.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M23.4 16.1v.1a.1.1 0 0 0 0-.2v.1Zm0 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m23.1 16 .1-.1h.1l-.1.2V16Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M23.1 16h.1v-.1Zm0-.1h.2v.1h-.1a.1.1 0 0 1-.1 0v-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m22.8 15.9.1-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M22.8 15.9a.1.1 0 0 0 .2 0 .1.1 0 0 0 0-.1h-.2Zm.1-.1v.1-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.5 15.8v-.1.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M22.6 15.7v.1Zm-.1.1a.1.1 0 0 1 .2 0 .1.1 0 0 1-.2 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.2 15.8v-.1.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M22.3 15.7v.1-.1Zm-.1 0a.1.1 0 1 1 0 .2v-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.9 15.8v-.1l.2.1h-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M21.9 15.8a.1.1 0 0 0 0 .1h.2v-.1l-.1-.1-.1.1Zm0 0h.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.6 15.8v-.1l.2.1h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m21.7 15.7-.1.1h.2-.1Zm-.1.1v-.1l.2.1-.1.1a.1.1 0 0 1-.1 0 .1.1 0 0 1 0-.1Zm0 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.7 16h.2-.2m0 .3h.2-.1Zm0 .3h.2-.1m-.1.3.1-.1h.1v.2l-.2-.1m-.2.2h.2v.1h-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M21.8 16v.1h.1V16h-.1Zm0 0h.1a.1.1 0 0 1-.2 0Zm0 .3v.1h.2v-.1h-.1Zm0 0h.2a.1.1 0 0 1-.2 0Zm0 .3Zm0 0Zm0 .2v.2-.1Zm0 0h.1v.2a.1.1 0 0 1-.2-.1Zm-.2.3v.1h.1V17h-.1Zm0 0h.2l-.2.1V17Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.3 15.6h.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M21.3 15.6a.1.1 0 0 0 .1.1.1.1 0 1 0 0-.2v.1Zm.1 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m21 15.5.2-.1v.2l-.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M21.1 15.4v.1h.1v-.1Zm0 0h.1v.1a.1.1 0 0 1-.1 0v-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.8 15.4v-.1h.2l-.1.2-.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M20.9 15.3h-.1v.1h.1v-.1Zm-.1 0h.2v.2h-.1l-.1-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.5 15.3h.2l-.1.1h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M20.5 15.3h.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.2 15.3h.2-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M20.1 15.3a.1.1 0 0 0 .2.1v-.2l-.2.1Zm.2 0h-.1v.1h.1v-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m19.8 15.4.1-.1h.1-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M19.8 15.4a.1.1 0 0 0 .3 0l-.2-.1Zm0 0h.2v-.1h-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.6 15.5v-.1h.2l-.1.2h-.1v-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M19.6 15.4v.1h.1v-.1h-.1Zm0 0h.2v.2h-.1a.1.1 0 0 1-.1 0 .1.1 0 0 1 0-.1v-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m14.6 17.9.1-.1h.1v.2l-.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M14.7 17.8v.1-.1Zm0 0a.1.1 0 0 1 .1 0v.2a.1.1 0 0 1-.2-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.5 17.6h.2l-.1.1h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M14.6 17.6v.1-.1Zm-.1 0h.2v.1h-.1a.1.1 0 0 1-.1 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.4 17.4v-.1h.2-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M14.4 17.4h.2l-.1-.1h-.1Zm0 0h.2l-.1-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.4 17h.2-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M14.4 17a.1.1 0 0 0 0 .2l.2-.1-.1-.2h-.1v.2Zm0 0v.1h.2l-.1-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.5 16.8v-.1h.1v.2l-.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M14.6 16.7v.2-.1Zm-.2 0h.2v.2a.1.1 0 0 1-.2-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.6 16.5h.2v.1h-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M14.6 16.5a.1.1 0 0 0 .1.1h.1l-.1-.2-.1.1Zm0 0h.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m14.8 16.3.1-.1h.1v.2l-.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M14.9 16.2v.2-.1Zm0 0h.1v.2a.1.1 0 0 1-.2-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15 16.1h.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M15.1 16v.2h.1V16Zm0 .1a.1.1 0 0 1 .2 0 .1.1 0 0 1-.3 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m15.3 16 .1-.1h.1v.2l-.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M15.4 16h.1v-.1h-.1Zm0-.1h.1v.1a.1.1 0 0 1-.2 0v-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m15.6 15.9.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M15.7 15.8v.1-.1Zm0 0a.1.1 0 1 1-.1 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 15.8v-.1.2-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M16 15.8v.1a.1.1 0 1 0 0-.2v.1Zm0 0h.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.3 15.8v-.1.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M16.3 15.7v.1-.1Zm0 0a.1.1 0 0 1 0 .2.1.1 0 0 1 0-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.6 15.8v-.1l.2.1h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m16.7 15.7-.1.1h.1Zm-.2.1.2-.1v.2a.1.1 0 0 1-.2-.1Zm0 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.9 15.8v-.1l.2.1h-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M16.8 15.8a.1.1 0 0 0 .2.1v-.2l-.2.1Zm.1 0h.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.7 16h.2-.2m0 .3h.1-.1Zm0 .3h.1-.2m.1.3.1-.1h.1v.2l-.2-.1Zm.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M16.7 16h.2-.1Zm0 0h.2a.1.1 0 0 1-.2 0Zm0 .3v.1h.1v-.1h-.1Zm0 0h.1a.1.1 0 0 1-.2 0Zm0 .3v.1h.1v-.2h-.1Zm0 0h.1a.1.1 0 0 1-.2 0Zm0 .2.1.2.1-.1h-.1Zm0 0h.2v.2a.1.1 0 0 1-.2 0 .1.1 0 0 1 0-.1Zm.2.3Zm0 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17 15.6h.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M17.1 15.6Zm0 0v-.1a.1.1 0 1 1 0 .1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.4 15.5v-.1h.1v.2l-.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M17.4 15.4v.1h.1v-.1h-.1Zm0 0h.1v.1a.1.1 0 0 1-.2 0v-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.7 15.4v-.1h.2l-.1.2-.1-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M17.6 15.4a.1.1 0 0 0 .3 0v-.1h-.2Zm.1-.1v.1h.1v-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18 15.3h.2-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M18 15.3a.1.1 0 0 0 0 .1h.2l-.1-.2H18v.1Zm0 0h.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.3 15.3h.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M18.3 15.3h.1Zm0 0h.1a.1.1 0 0 1-.1 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.6 15.4v-.1h.2-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M18.6 15.4h.2l-.1-.1h-.1Zm0 0h.2l-.1-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.9 15.5v-.1h.2-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M18.9 15.5h.2l-.1-.1h-.1v.1Zm0 0h.1v-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M16.4 21.5h-.1v-.1H16v.3h.2v.2H16v.7h.1v1.3h-.3v.7h2.6V24H18v-1.3h.2V22H18v-.2h.1v-.3h-.7v.3h.2v.2h-.4v-.7h.2V21h-.6v.3h.1v.7h-.3v-.2h.2v-.3h-.4Zm-.6 3.1h2.6-2.6Zm0-.2h2.6-2.6Zm0-.1h2.6-2.6Zm0-.2h2.6-2.6Zm0-.2h2.6-2.6Zm.3-.1h2-2Zm0-.2h2-2Zm0-.2h2-2Zm0-.1h2-2Zm0-.2h2-2Zm0-.2h2-2Zm0-.1h2-2Zm-.1-.2h2.2H16Zm0-.2h2.2H16Zm0-.1h2.2H16Zm0-.2h2.2H16Zm.3-.2h1.6-1.6Zm.6-.1h.3-.3Zm0-.2h.3-.3Zm0-.2h.3-.3Zm0-.1h.3-.3Zm-.1-.2h.6-.6Zm-.5.7h.3-.3Zm-.1-.2h.6-.6Zm0 3v-.2.2Zm0-.3V24v.2Zm-.2 0v.1-.1Zm.3.1v-.1.1Zm.2.2v-.2.2Zm0-.3V24v.2Zm0-.4v-.1.1Zm0-.3v-.2.2Zm-.2.5V24v.2Zm-.3 0V24v.2Zm.6-.2v.2-.2Zm.2 0v-.1.1Zm-.5-.3v.2-.2Zm.3 0v.2-.2Zm.3 0v.2-.2Zm-.1 0v-.2.2Zm.1-.3v.1-.1Zm0-.4v.2-.2Zm-.1-.1v.1-.1Zm.1-.2v.2-.2Zm-.3 0v.2-.2Zm-.3 0v.2-.2Zm-.1-.2v.2-.2Zm.3 0v.2-.2Zm.3 0v.2-.2Zm.1-.1v.1-.1Zm-.3 0v.1-.1Zm-.3 0v.1-.1Zm-.1-.2v.2-.2Zm.6 0v.2-.2Zm-.3-.3v.1-.1Zm1.4 0h-.3.3Zm.1-.2h-.6.6Zm0 3v-.1.1Zm0-.3V24v.2Zm.2 0v.2-.2Zm-.3.2v-.2.2Zm-.2.1v-.2.2Zm0-.3V24v.2Zm0-.4v-.1.1Zm0-.3v-.2.2Zm.2.5V24v.2Zm.3 0V24v.2Zm-.6-.2v.2-.2Zm-.2 0v-.1.1Zm.5-.3v.2-.2Zm-.3 0v.2-.2Zm-.3 0v.2-.2Zm.1 0v-.2.2Zm-.1-.3v.1-.1Zm0-.4v.2-.2Zm.1-.1v.1-.1Zm-.1-.2v.2-.2Zm.3 0v.2-.2Zm.3 0v.2-.2Zm.1-.2v.2-.2Zm-.3 0v.2-.2Zm-.3 0v.2-.2Zm-.1-.1v.1-.1Zm.3 0v.1-.1Zm.3 0v.1-.1Zm.1-.2v.2-.2Zm-.6 0v.2-.2Zm.3-.3v.1-.1Zm-.6 1.8v-.2.2Zm0-.7v-.1.1Zm0 .4V23v.2Zm0-.7v-.2.2Zm0-.3V22v.2Zm0-.5v-.2.2Zm0-.4v-.1.1Zm-.8.3h.3-.3Zm.6-.5h.4-.4Zm.7.5h.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M16.8 20.9h.6v.3h-.1v.7h.2v-.2h-.1v-.4h.2v.1h.5v.3h-.2v.2h.3v.7h-.1V24h.3v.7h-2.6V24h.3v-1.3H16V22h.3v-.2H16v-.4h.2v.1h.5v.3h-.2v.2h.3v-.7h-.1V21Zm.6.3V21h-.6.6Zm-.6-.2h.6-.6v.1Zm.4.2H17h.2Zm0 0h-.1v.2h.1v-.1Zm0 .3H17h.2Zm0 .1h-.1v.1h.1Zm0 .2H17v.1h.2v-.1ZM16 22h2.2H16Zm1.6 0h.1v-.2h-.1v.1Zm0-.2h.3-.3Zm.4-.1v-.1h-.6.6Zm-.6-.1h.6v-.2h-.5v.2Zm.5.2h-.1v.1-.1Zm.3.3H18v.1Zm0 .2h-.3v.1h.3v-.1Zm0 .2H18Zm-.2 0h-.2.2Zm0 .1v.2-.2Zm0 .2h-.6v.1h.6v-.1Zm0 .1h-.7v.2h.7v-.2Zm0 .2h-.9v.1h1Zm0 .2h-.7v.1h.7v-.1Zm0 .1h-.2v.2h.2v-.2Zm0 .2v.2-.2Zm0 .2h-.2v.1h.2v-.1Zm0 .2v.1h.2V24h-.3Zm.2 0v.1h.1V24Zm.1.1h-.2v.2h.2V24Zm0 .2v.1-.1Zm0 .2h-.2v.1h.2v-.1Zm-.3.1v-.1h-.2v.1h.2Zm-.3 0v-.1h-1.2v.1h1.2Zm-1.3 0v-.1h-.2v.1h.2Zm-.3 0v-.1h-.3v.1h.3Zm-.3-.2h.2v-.1h-.2v.1Zm0-.1h.3V24h-.3v.2Zm0-.2h.2V24h-.2v.1Zm.2-.1v.1h.3V24H16Zm.2 0h.2v-.2h-.2v.1Zm0-.2v-.2.2Zm0-.2h.2v-.2h-.2v.2Zm0-.2h.7v-.1h-.7v.1Zm0-.1h.9V23h-1v.1Zm0-.2h.7v-.2h-.7v.2Zm0-.2h.6v-.1h-.6v.1Zm0-.1v-.2.2Zm0-.2h.2v-.1h-.2Zm0-.1H16h.1Zm-.2 0h.3v-.2H16v.1Zm0-.3h.1-.1Zm.2 0h.6-.6Zm.6 0h.3-.3Zm.3 0h.3-.3Zm.3 0h.6-.6Zm-1 0v.2h.2v-.1h-.3Zm.3 0v.2h.2v-.1h-.3Zm.3 0v.2h.2v-.1H17Zm.3 0v.2h.3v-.1h-.3Zm.3 0v.2h.3v-.1h-.3Zm-1.1.3h.3-.3Zm.3 0h.3-.3Zm.3 0h.3-.3Zm.3 0h.3-.3Zm-1 .1v.2h.2v-.2h-.3Zm.3 0v.2h.2v-.2h-.3Zm.3 0v.2h.2v-.2H17Zm.3 0v.2h.3v-.2h-.3Zm.3 0v.2h.3v-.2h-.3Zm-.8.2v.1h.3v-.1h-.3Zm.3 0v.1h.3v-.1h-.3Zm-.1.1v.2h.2v-.2H17Zm0 .4v.1h.2v-.1H17Zm-.5.1v.2h.3v-.2h-.3Zm.3 0v.2h.3v-.2h-.3Zm.3 0v.2h.3v-.2h-.3Zm.3 0v.2h.3v-.2h-.3Zm-1 .2v.2h.2v-.2h-.3Zm.2 0v.2h.3v-.2h-.3Zm.3 0v.2h.3v-.2H17Zm.4 0v.2h.3v-.2h-.3Zm.3 0v.2h.3v-.2h-.3Zm-1.1.2v.1h.3v-.1h-.3Zm.3 0v.1h.6v-.1h-.6Zm.6 0v.1h.3v-.1h-.3Zm-1 .2v.1h.2V24h-.3Zm.3 0v.1h.8V24h-.9Zm.9 0v.1h.3V24h-.3Zm-1.4.1v.2h.2V24h-.2Zm.3 0v.2h1.2V24h-1.2Zm1.3 0v.2h.2V24h-.2Zm-1.8.2v.1h.3v-.1H16Zm.3 0v.1H18v-.1h-1.6Zm1.6 0v.1h.3v-.1h-.3Zm-1.6-2.4h.1v-.1.1Zm0-.1h.3-.3Zm.5-.1v-.1h-.6.6Zm-.6-.2h.6v-.1h-.6v.1Zm.4.3h-.1v.1h.1v-.1Zm.4 0v-.2.1Zm0-.4v-.1.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M17.5 24.6v-.4c0-.1 0-.3-.4-.3s-.4.2-.4.3v.4h.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m16.7 24 .4-.2.4.2v.6h-.9v-.4l.1-.2Zm0 0v.6h.8V24l-.4-.1-.4.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M16.8 24.2h-.2v-.3l.3.2v.1Zm.6 0h.2l-.1-.3-.2.2v.1Zm-.2-.2v-.2H17l.1.2h.2Zm-.4-.5V23c0-.1-.1-.2-.3-.2-.1 0-.2 0-.2.2v.5h.5Zm.6 0V23l.2-.2c.2 0 .3 0 .3.2v.5h-.5Zm-.1-1.1v-.5h-.4v.5h.4Zm.3 0v-.5h.3v.5h-.3Zm-1 0v-.5h-.4v.5h.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M16.2 22h.5v.4h-.4v-.5Zm0 0 .1.3h.3V22h-.3Zm.7 0h.4v.4h-.4v-.5Zm0 0v.3h.3V22H17Zm.6 0h.5l-.1.4h-.4v-.5Zm0 0v.3h.4V22h-.4Zm-1.1.8h.1c.2 0 .3 0 .3.2v.5h-.5v-.7Zm0 0v.7h.4V23c0-.1-.1-.2-.3-.2h-.1Zm1.2 0-.2.2v.5h.5V23l-.1-.1h-.2Zm-.2.2c0-.1 0-.2.2-.2h.2v.7h-.4V23Zm-.3.7h.2l-.1.3H17l-.1-.2h.2Zm0 0-.2.1.1.2h.2v-.2h-.1Zm-.4.2.2.2v.1h-.3V24Zm0 .3a.3.3 0 0 1 .1-.1l-.1-.1v.2Zm.8-.3v.1l.1.2h-.2l-.1-.1.2-.2Zm-.1.3h.2V24h-.4a.3.3 0 0 1 0 .2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0039F0",
    d: "M17.4 24.6v-.4s0-.2-.3-.2c-.2 0-.3.2-.3.2v.4h.6Zm-.7-1.2V23s0-.2-.2-.2l-.1.2v.4h.3Zm.8 0V23l.1-.2c.2 0 .2.1.2.2v.4h-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "M17.9 25.3c0-1 .6-1.7 1.5-1.7.8 0 1.4.8 1.4 1.7 0 .9-.6 1.6-1.4 1.6-.9 0-1.5-.7-1.5-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M19.4 23.7c-.8 0-1.5.7-1.5 1.6 0 .9.7 1.6 1.5 1.6.7 0 1.4-.7 1.4-1.6 0-.9-.7-1.6-1.4-1.6Zm-1.5 1.6c0-1 .6-1.7 1.5-1.7.8 0 1.4.8 1.4 1.7 0 1-.6 1.7-1.4 1.7-.9 0-1.5-.8-1.5-1.7Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005BBF",
    d: "M18.3 25.3c0-.7.5-1.2 1-1.2.6 0 1 .5 1 1.2s-.4 1.2-1 1.2c-.5 0-1-.5-1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M19.3 24.1c-.5 0-1 .5-1 1.2 0 .6.5 1.2 1 1.2.6 0 1-.6 1-1.2 0-.7-.4-1.2-1-1.2Zm-1 1.2c0-.7.5-1.2 1-1.2.6 0 1.1.5 1.1 1.2s-.5 1.2-1 1.2c-.6 0-1.1-.5-1.1-1.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M18.9 24.5s-.2 0-.2.2l.1.2h-.3v.2h.4v.1h-.1v.2h.2v-.3h.1l.1-.1a.1.1 0 0 0-.1-.1h-.2v-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M19 24.5v.4a.1.1 0 0 1 .2 0v.2H19v.4l-.1.1h-.2v-.5h-.1v-.4h.2v-.3a.5.5 0 0 1 .1 0Zm-.1 0v.2a.5.5 0 0 1 0 .2h.2v.2a.1.1 0 0 0-.1 0v.4h-.2v-.1h-.1.1v-.1l-.1-.1h-.1V25h.2v-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M18.7 25.3h.4-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M18.7 25.2h.4v.1h-.4v-.1Zm0 0h.3-.3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m19.8 24.5-.1.2v.2h-.2v.2h.2v.4h.3v-.4h.1V25a.1.1 0 0 0 0-.1h-.2v-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M19.9 24.5v.4h.1a.1.1 0 0 1 .2 0v.2h-.4v.1h.1v.2h-.1v.1h-.2v-.4h-.1l-.1-.1.1-.2h.1v-.3h.1a.5.5 0 0 1 .1 0Zm0 0v.2a.5.5 0 0 1 0 .2h.1a.1.1 0 0 1 .1 0v.2a.1.1 0 0 0-.2 0v.1h.1v.2h-.3v-.2a.1.1 0 0 0 0-.1h-.1l-.1-.1.1-.1h.1a.5.5 0 0 1 0-.2v-.2h.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M19.6 25.3h.4-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M19.6 25.2h.4v.1h-.4v-.1Zm0 0h.4-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M19.3 25.3v.5l-.2-.1v.3h.2-.1v.3h.4v-.4h.1a.1.1 0 0 0 0-.2h-.2v-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M19.3 25.3a.6.6 0 0 1 .1 0v.4a.2.2 0 0 1 .2 0 .1.1 0 0 1 0 .1v.2h-.2.1v.3h-.4v-.4H19l.1-.2h.1v-.3a.7.7 0 0 1 .1-.1Zm0 0v.2a.5.5 0 0 0 0 .2H19v.2a.1.1 0 0 1 .2.1h-.1v.2h.5V26a.1.1 0 0 1 0-.1.1.1 0 0 1 .1 0 .1.1 0 0 0 0-.2h-.2v-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M19.2 26.1h.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M19.1 26h.5v.1H19Zm0 0v.1h.4-.3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M22.3 21H22v-.1l-.1-.2v.2l.2.2.2.2h.3-.2V21h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M21.9 20.7v.1h.1v.1h.2v.1h.1v.1h.1v.1h.2v.1a.5.5 0 0 0-.2 0l-.3-.2-.3-.1a.3.3 0 0 0 0-.1v-.1l.1-.1Zm0 .1a.3.3 0 0 1 0 .2l.2.1.2.2h.1v-.1h-.1V21H22v-.1h-.2Zm.1.2Zm0 0Zm0 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M22.2 21v.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M22.1 21h.1v.1Zm0 0v.1h.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M22 21Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M22 21Zm0 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M22 21s-.1 0 0 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M22 20.9h-.1Zm0 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M22.2 21.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M22.2 21.1Zm0 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M22.3 21.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M22.3 21.2Zm0 0Zm.1 0Zm0 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M22.1 20.7v.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M22 20.7h.1v.1Zm.1 0v.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M22 20.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m22 20.7.1.1H22Zm0 0v.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M22.2 20.9H22"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M22 20.8h.2v.1H22Zm.2 0H22Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M22 20.8h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M22 20.8h.1Zm0 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M21.9 20.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M21.8 20.6v.1Zm0 .1c0-.1 0 0 0 0h.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M22 20.8h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M21.8 20.7h.2v.1h-.2v-.1Zm.1 0Zm0 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M22.3 20.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M22.3 20.8v.1Zm0 0v.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M22.2 20.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M22.2 20.9Zm0 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M22.4 21h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M22.3 21Zm0 0Zm-.1 0Zm0 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M22.5 21v.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M22.5 21v.1-.1Zm0 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M22.5 21.2V21"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m22.4 21 .1.1Zm.1.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M22.4 21v.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M22.4 21v.1-.1Zm0 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M22.5 21.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M22.4 21v.1Zm0 .1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M22.6 21.3h.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M22.7 21.2v.1h-.2a.1.1 0 0 1 .1 0Zm0 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M22.5 21.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M22.6 21.2v.1h-.1v-.1h.1Zm0 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M26 19h.1v.3H26h.1V19Zm.1.2v-.1H26v.1h.1Zm-3.6 2h.1v.1Zm-10-1v.2-.2Zm-.2 0v.1Zm0 0v.1Zm0 0v.1Zm0 0v.1Zm.1 0v.1Zm0 0v.1Zm0 0v.1Zm0 0v.1Zm-.1 0v.1Zm0 0v.1Zm0 0v.1h-.1Zm0 0v.1Zm0 0v.1Zm-.1 0v.1Zm0 0v.1Zm0 0v.1Zm-.1.1Zm13.7 0Zm0 0Zm0 0Zm0 0Zm0 0Zm0 0Zm0 0Zm.1 0Zm0 0Zm-.2 0Zm0 0Zm0 0Zm0 0Zm0 0Zm-.1 0Zm0 0Zm0 0Zm0 0Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v45H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEs);
export default __webpack_public_path__ + "static/media/es.ea18caaada5a7349c3b7e8532b3c301e.svg";
export { ForwardRef as ReactComponent };